/* eslint-disable no-unused-vars */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React, {
  useState, useEffect, useRef,
} from 'react';
import {
  Form,
  Button,
  DatePicker,
  Row,
  Col,
  Spin,
  Card,
  Input,
  Tabs,
  Tag,
  TreeSelect,
  Modal,
  message,
  Typography,
  Select as AntdSelect,
} from 'antd';
import { formatReceivedValues } from 'utils/formatValues';
import { areaBuscar, normalizeData } from 'utils/normalizers';
import { onError } from 'utils/handlers';
import Table from 'components/Table';
import FormSubmitControls from 'components/FormSubmitControls';
import useSeguimientoDeRegistro from 'hooks/useSeguimientoDeRegistro';
import currencyFormatter from 'utils/currencyFormatter';
import CurrencyInput from 'components/CurrencyInput';
import ModalDelete from 'components/ModalDelete';
import ModalConfirmation from 'components/ModalConfirmation';
import ModalDuplicate from 'views/Configuracion/Accesos/ModalDuplicate';
import ExportadorExcelPersonalizado from 'components/ExportadorExcelPersonalizado';
import Select from 'components/Select';
import {
  CopyOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  StopOutlined,
  InfoCircleOutlined,
  UserOutlined,
  DollarOutlined,
  ReloadOutlined,
  FileExcelOutlined,
  UndoOutlined,
} from '@ant-design/icons';
import {
  getTiposDeEmpleados,
  getAreas,
  getContentTypesUR,
  getFuentesDeFinanciamientoContabilidad,
  getCOGS,
} from 'api/catalogos/index';
import {
  getPuestos,
} from 'api/estructuraOrganizacional/puestos';
import {
  getPlazas,
  postPlaza,
  deletePlaza,
  patchPlaza,
  getPlaza,
  getCategorias,
  duplicarPlaza,
  putAutorizarPlaza,
  putSuspenderPlaza,
  putInactivarPlaza,
  putActivarPlaza,
  putReactivarPlaza,
  getPlazasvistaOptimized,
} from 'api/catalogos/plazas';
import {
  getTabuladoresGenerales,
} from 'api/nominas/tabuladores/tabuladoresGenerales';
import {
  getTiposDePlazas,
} from 'api/nominas/catalogos/tiposDePlazas';
import {
  getNivelesSalarialesTabulares,
} from 'api/nominas/catalogos/nivelesSalarialesTabulares';
import {
  getTabuladoresNominales,
} from 'api/nominas/tabuladores/tabuladoresNominales';
import { checkToken } from 'api/utils';
import { readPersistedTableQuery } from 'utils/tableFiltersStorage';
import {
  SLUG_PATTERN,
  FLOAT_NUMER_PATTERN,
} from 'utils/patterns';
import {
  getEstadosPlazas,
} from 'api/catalogos/estadosPlazas';
import {
  ESTADO_PLAZA_ACTIVA,
  ESTADO_PLAZA_AUTORIZADA,
  ESTADO_PLAZA_DISPONIBLE,
  ESTADO_PLAZA_SUSPENDIDA,
  ESTADO_PLAZA_ASIGNADA,
  ESTADO_PLAZA_POR_ASIGNAR,
  ESTADO_PLAZA_INACTIVA,
  ESTATUS_AUTORIZADO,
  ESTATUS_CANCELADO,
  ESTATUS_ACTIVO,
} from 'utils/constants';
import API from 'utils/api';
import makeThreeFromCOG from 'utils/makeTree';
import { getTiemposDeContrataciones } from 'api/catalogos/tiemposDeContrataciones';
import { getClasesDeContrataciones } from 'api/nominas/catalogos/clasesDeContrataciones';
import { getTiposDeNominasEmpleados } from 'api/nominas/catalogos/tiposNominasEmpleados';
import { set } from 'lodash';
import { getJornadas } from 'api/catalogos/jornadas';
import { getJornadasDetalle } from 'api/catalogos/JornadaDetalle';
import { getAdministracionDePlazas, getAdministracionDePlazasvistaOptimized, getSujetosDeNomina } from 'api/catalogos/admnistracionDePlazas';
import { getTiposAsignacion } from 'api/catalogos/TipoAsignacionDePlaza';
import { getTiposRegimenesNominas } from 'api/catalogos/tiposRegimenesNominas';
import { getChecados } from 'api/catalogos/TiposDeChecado';
import { getZonasDeSalariosMinimos } from 'api/catalogos/zonasDeSalariosMinimos';
import { getTiposDeFunciones } from 'api/catalogos/tiposDeFunciones';
import { getPeriodicidadesDePagos } from 'api/catalogos/periodicidadesDePagos';
import { getTiposDeSueldos } from 'api/catalogos/tiposDeSueldos';
import { getProyectoPresupuestales } from 'api/catalogos/ProyectoPresupuestal';
import { ca, pl } from 'date-fns/locale';
import { getPercepciones } from 'api/nominas/percepciones/percepciones';
import { getPeriodicidadDePercepciones } from 'api/nominas/percepciones/periodicidadDePercepciones';
import { getTiposDeContrataciones } from 'api/catalogos/tiposDeContrataciones';
import { getTiposDeActividades } from 'api/catalogos/TiposDeActividades';
import {
  deletePlazaCosto, getPlazaCostos, patchPlazaCosto, sincronizarPercepcionesDePlaza,
} from 'api/catalogos/PlazaCosto';
import { getPlazasContribucionesSobreNomina } from 'api/catalogos/plazasContribucionesSobreNomina';
import { getPeriodosFiscales } from 'api/configuraciones/periodosFiscales';
import { getTiposDeEmpleadosPresupuestales } from 'api/catalogos/tiposDeEmpleadosPresupuestales';
import {
  getHistorialesSueldoPlaza,
  postHistorialSueldoPlaza,
  patchHistorialSueldoPlaza,
  deleteHistorialSueldoPlaza,
} from 'api/catalogos/historialSueldoPlaza';
import { getFuncionesPresupuestales } from 'api/catalogos/DestinoPresupuestal';
import { getProgramasPresupuestales } from 'api/catalogos/ProgramaPresupuestal';
import moment from 'moment';

// Orden: Estatus ascendente (Activo→Autorizado→Cancelado) y fecha_inicial descendente
const sortHistorial = (list) => [...list].sort((a, b) => {
  const ea = a.estados_globales ?? 1;
  const eb = b.estados_globales ?? 1;
  if (ea !== eb) return ea - eb;
  return (b.fecha_inicial || '').localeCompare(a.fecha_inicial || '');
});

export const plazasPermission = {
  permissionModel: 'plaza',
  catalogsModels: [
    'tipodecontratacion',
    'plazacontribucionessobrenomina',
    'periodofiscal',
  ],
  tabsModels: [],
};

const { TabPane } = Tabs;
const baseURI = 'catalogos/plaza';

// Campos que viven en la pestaña "Sueldo" del formulario de Plazas (comparten
// la misma instancia de `form` que la pestaña "Generales"). Se usa para saber
// a qué pestaña cambiar cuando `form.validateFields()` falla en un campo que
// no está visible en la pestaña activa.
const SUELDO_TAB_FIELDS = [
  'desde_sueldo_mensual_nominal',
  'hasta_sueldo_mensual_nominal',
  'sueldo_mensual_nominal_asignado',
  'desde_sueldo_diario_nominal',
  'hasta_sueldo_diario_nominal',
  'sueldo_diario_nominal_asignado',
  'periodicidad_de_pago',
  'tipo_de_sueldo',
  'zona_de_salario_minimo',
  'fuente_financiamiento',
  'presupuesto',
  'proyecto_presupuestal',
  'programa_presupuestal',
  'destino_presupuestal',
  'tipo_de_empleado_presupuestal',
];

// Catálogo de sujetos de nómina (Empleado / Becario / Honorario Asimilado) para filtrar el listado.
// Único punto a extender si en el futuro se agrega un nuevo tipo de sujeto.
const SUJETOS_DE_NOMINA_FALLBACK = [
  { slug: 'empleado', etiqueta: 'Empleado' },
  { slug: 'becario', etiqueta: 'Becario' },
  { slug: 'honorarioasimilado', etiqueta: 'Honorario Asimilado' },
];

// Oculta temporalmente el botón "Suspender" a petición del usuario (2026-09-01),
// sin quitar el resto de la lógica (handler, modal, permisos) para poder
// reactivarlo fácilmente después.
const MOSTRAR_SUSPENDER = false;

// Tabs por estatus del listado principal de Plazas.
const TAB_ACTIVA = 'activa';
const TAB_AUTORIZADA = 'autorizada';
const TAB_DISPONIBLE = 'disponible';
const TAB_ASIGNADA = 'asignada';
const TAB_SUSPENDIDA = 'suspendida';
const TAB_INACTIVA = 'inactiva';
const TAB_TODOS = 'todos';

const TAB_ESTADO_PLAZA = {
  [TAB_ACTIVA]: ESTADO_PLAZA_ACTIVA,
  [TAB_AUTORIZADA]: ESTADO_PLAZA_AUTORIZADA,
  [TAB_DISPONIBLE]: ESTADO_PLAZA_DISPONIBLE,
  [TAB_ASIGNADA]: ESTADO_PLAZA_ASIGNADA,
  [TAB_SUSPENDIDA]: ESTADO_PLAZA_SUSPENDIDA,
  [TAB_INACTIVA]: ESTADO_PLAZA_INACTIVA,
  // `null` -> no se envía `estado_plaza` y el API regresa las Plazas de todos los
  // estatus (el filtro es opcional en PlazaFilterSet).
  [TAB_TODOS]: null,
};

const paramsEstadoPlaza = (tabKey) => {
  const estado = TAB_ESTADO_PLAZA[tabKey];
  return estado ? { estado_plaza: estado } : {};
};

// Id fijo de la tabla principal: todos los tabs comparten la misma búsqueda ("plazas").
const TABLE_STORAGE_ID = 'plazas';
// Búsqueda capturada en cualquier tab (se incluye al pedir los datos de otro tab o al recargar).
const busquedaGuardada = () => readPersistedTableQuery(window.location.pathname, {
  storageId: TABLE_STORAGE_ID,
});

const CategoriaDePuesto = ({ permission }) => {
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [visibleDuplicate, setVisibleDuplicate] = useState(false);
  const [data, setData] = useState([]);
  const [fullDataParaExportar, setFullDataParaExportar] = useState([]);
  const [showExportador, setShowExportador] = useState(false);
  const [sujetoFiltro, setSujetoFiltro] = useState(null);
  const [sujetosDeNomina, setSujetosDeNomina] = useState(SUJETOS_DE_NOMINA_FALLBACK);
  const [tiposEmpleados, setTiposEmpleados] = useState([]);
  const [fuentes, setFuentes] = useState([]);
  const [nivelesTabulares, setNivelesTabulares] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [puestos, setPuestos] = useState([]);
  const [tipoEmpleado, setTipoEmpleado] = useState();
  const [areas, setAreas] = useState();
  const [contentTypes, setContentTypes] = useState([]);
  const [tabuladoresGenerales, setTabuladoresGenerales] = useState([]);
  const [tiposPlazas, setTiposPlazas] = useState([]);
  const [tabuladorGeneral, setTabularGeneral] = useState();
  const [sueldoMensualDesde, setSueldoMensualDesde] = useState(0);
  const [sueldoMensualHasta, setSueldoMensualHasta] = useState(0);
  const [nivelTabular, setNivelTabular] = useState();
  const [tabuladoresNominales, setTabuladoresNominales] = useState([]);
  const [presupuesto, setPresupuesto] = useState(0);
  const [estadosPlazas, setEstadosPlazas] = useState([]);
  const [disable, setDisable] = useState(false);
  const [disableStatus, setDisableStatus] = useState(false);
  const [rowConditionals, setRowConditionals] = useState(true);
  const [disableDuplicar, setDisableDuplicar] = useState(true);
  const [visibleAuthConfirmation, setVisibleAuthConfirmation] = useState(false);
  const [visibleAuthSuspender, setVisibleAuthSuspender] = useState(false);
  const [visibleInactivar, setVisibleInactivar] = useState(false);
  const [visibleActivar, setVisibleActivar] = useState(false);
  const [visibleAuthReactivar, setVisibleAuthReactivar] = useState(false);
  const [canAutorizar, setCanAutorizar] = useState(false);
  const [canSuspender, setCanSuspender] = useState(false);
  const [canInactivar, setCanInactivar] = useState(false);
  const [canReactivar, setCanReactivar] = useState(false);
  const [canActivar, setCanActivar] = useState(false);
  // La pantalla abre en "Todos" (primer tab).
  const [activeTab, setActiveTab] = useState(TAB_TODOS);
  const [formInactivar] = Form.useForm();
  const [formActivar] = Form.useForm();
  const [currentParentTabKey, setCurrentParentTabKey] = useState('general');
  const [activeTabSueldo, setActiveTabSueldo] = useState('sueldo');
  const [activeTabPercepciones, setActiveTabPercepciones] = useState('percepciones-costos');
  const [tiemposDeContrataciones, setTiemposDeContrataciones] = useState([]);
  const [tiposDeContrataciones, setTiposDeContrataciones] = useState([]);
  const [tiposNominasEmpleados, setTiposNominasEmpleados] = useState([]);
  const [jornada, setJornada] = useState([]);
  const [jornadadetalle, setJornadadetalle] = useState([]);
  const [jornadaSeleccionada, setJornadaSeleccionada] = useState(null);
  const [administraciondeplaza, setAdminitracionDePlaza] = useState(false);
  const [tiposDeAsignacion, setTiposDeAsignacion] = useState([]);
  const [tiposRegimenesNominas, setTiposRegimenesNominas] = useState([]);
  const [tiposChecado, setTiposChecado] = useState([]);
  const [zonasDeSalariosMinimos, setZonasDeSalariosMinimos] = useState([]);
  const [tiposDeFunciones, setTiposDeFunciones] = useState([]);
  const [tiposDeActividades, setTiposDeActividades] = useState([]);
  const [tiposDeSueldos, setTiposDeSueldos] = useState([]);
  const [periodicidadesDePagos, setPeriodicidadesDePagos] = useState([]);
  const [proyectoPresupuestal, setProyectoPresupuetal] = useState([]);
  const [pageActual, setPageActual] = useState(1);
  const [dataPercepciones, setDataPercepciones] = useState([]);
  const [dataContribuciones, setDataContribuciones] = useState([]);
  const [periodosFiscales, setPeriodosFiscales] = useState([]);
  const [periodoFiscalHistorial, setPeriodoFiscalHistorial] = useState();
  const [historialPercepciones, setHistorialPercepciones] = useState([]);
  const [historialContribuciones, setHistorialContribuciones] = useState([]);
  const [periodicidadPercepciones, setPeriodicidadPercepciones] = useState([]);
  const [cogs, setCogs] = useState([]);
  const [plazaCostos, setPlazaCostos] = useState([]);
  const [clasesDeContrataciones, setClasesDeContrataciones] = useState([]);
  const [programasPresupuestales, setProgramasPresupuestales] = useState([]);
  const [funcionesPresupuestales, setFuncionesPresupuestales] = useState([]);
  const [tiposDeEmpleadosPresupuestales, setTiposDeEmpleadosPresupuestales] = useState([]);
  const [disableFields, setDisableFields] = useState(false);
  const [selectedPercepcionKeys, setSelectedPercepcionKeys] = useState([]);
  const [formCosto] = Form.useForm();
  const [visibleEditCosto, setVisibleEditCosto] = useState(false);
  const [visibleDeleteCosto, setVisibleDeleteCosto] = useState(false);
  const [costoSeleccionado, setCostoSeleccionado] = useState(null);

  // Historial Sueldo Plaza
  const [formHistorial] = Form.useForm();
  const [historialSueldo, setHistorialSueldo] = useState([]);
  const [selectedHistorialKeys, setSelectedHistorialKeys] = useState([]);
  const [historialSeleccionado, setHistorialSeleccionado] = useState(null);
  const [visibleHistorialModal, setVisibleHistorialModal] = useState(false);
  const [visibleDeleteHistorial, setVisibleDeleteHistorial] = useState(false);
  const [visibleConfirmAutorizarHistorial, setVisibleConfirmAutorizarHistorial] = useState(false);
  const [visibleConfirmCancelarHistorial, setVisibleConfirmCancelarHistorial] = useState(false);
  const [selectedPlazaKeys, setSelectedPlazaKeys] = useState([]);
  const [selectedPlazaData, setSelectedPlazaData] = useState({});
  const [flatAreas, setFlatAreas] = useState([]);
  const nameAplicaJornada = 'aplica_reloj_checador'; // cambio de title repentino
  const nameJornada = 'jornada';
  const nameJornadaDetalle = 'jornada_detalle';
  const watcherAplicaJornada = Form.useWatch(nameAplicaJornada, form);
  // `estados_globales` no tiene un Form.Item propio en este formulario (a
  // diferencia de `estado_plaza`, que sí lo tiene vía el Select de Estatus),
  // por lo que Form.useWatch nunca lo detecta aunque se envíe con
  // form.setFieldsValue: rc-field-form solo notifica watchers para paths que
  // algún Field ya registró. Se guarda en estado aparte, tomado directo del
  // Plaza recién cargado en onClickEdit (misma fuente que ya usa disableFields).
  const [estadosGlobalesPlazaActual, setEstadosGlobalesPlazaActual] = useState(null);
  const watcherEstadoPlaza = Form.useWatch('estado_plaza', form);
  // "Guardar y Continuar" solo debe verse habilitado al Reactivar (la Plaza
  // queda estados_globales:1 estado_plaza:Activa) o cuando ya está
  // estados_globales:1 estado_plaza:Por Asignar. Al Agregar (sin registro
  // seleccionado) siempre se permite guardar.
  const allowGuardarYContinuar = !selectedRowKeys.length || (
    estadosGlobalesPlazaActual === ESTATUS_ACTIVO
    && (watcherEstadoPlaza === ESTADO_PLAZA_ACTIVA || watcherEstadoPlaza === ESTADO_PLAZA_POR_ASIGNAR)
  );

  useEffect(() => {
    if (watcherAplicaJornada || watcherAplicaJornada == null) {
      return;
    }
    form.setFieldsValue({ [nameJornada]: null, [nameJornadaDetalle]: null });
  }, [watcherAplicaJornada]);

  // Sujetos ('becario'/'honorarioasimilado') cuya Plaza folia
  // automáticamente (BEC-00001/HON-00001) al crearse o duplicarse; ver
  // catalogos/utils/generar_folio_plaza.py en el backend.
  const [claveAutoGenerada, setClaveAutoGenerada] = useState(false);
  const watcherTipoDeNominaEmpleado = Form.useWatch('tipo_de_nomina_empleado_descripcion', form);

  useEffect(() => {
    const tipoSeleccionado = tiposNominasEmpleados
      .find((item) => item.id === watcherTipoDeNominaEmpleado);
    const sujeto = tipoSeleccionado?.content_type_model;
    setClaveAutoGenerada(sujeto === 'becario' || sujeto === 'honorarioasimilado');
  }, [watcherTipoDeNominaEmpleado, tiposNominasEmpleados]);

  // ────────────────────────────────────────────────────────────────
  // Definiciones que se usan en onClickExportarExcel
  // ────────────────────────────────────────────────────────────────

  const formatReceivedClone = (values) => {
    if (Array.isArray(values)) {
      let valueClone = values.map((e) => formatReceivedValues(e));
      valueClone = valueClone.map((e) => ({
        ...e,
        puestoTG: e?.puesto,
        puestoSTD: e?.puesto,
        puestoSTH: e?.puesto,
        puestoNST: e?.puesto,
        tabulador_nominal_NSN: e?.tabulador_nominal,
        tabulador_nominalSNM: e?.tabulador_nominal,
        tabulador_nominal_presupuesto: e?.tabulador_nominal,
      }));
      return valueClone;
    }
    return formatReceivedValues(values);
  };

  const registrosPlazas = data?.results || [];
  const seguimiento = useSeguimientoDeRegistro({
    contentTypeAppLabel: 'catalogos',
    contentTypeModel: 'plaza',
    moduloDescripcion: 'Nómina',
    documentoOperativoDescripcion: 'Plazas',
    moduloOrigenLabel: 'Plazas',
    registros: registrosPlazas,
    seleccionIds: selectedRowKeys,
    registroActivo: open && selectedRowKeys.length
      ? registrosPlazas.find((e) => e.id === selectedRowKeys[0]) || { id: selectedRowKeys[0] }
      : null,
    mutable: true,
    getRegistroLabel: (row) => `Plaza ${row.clave || row.id}`,
  });

  const columns = [
    {
      titleText: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 80,
    },
    {
      titleText: 'Clave',
      dataIndex: 'clave_y_descripcion',
      key: 'clave_y_descripcion',
      width: 200,
    },
    {
      titleText: 'Tipo de Plaza',
      dataIndex: 'tipo_de_plaza_descripcion',
      key: 'tipo_de_plaza_descripcion ',
      width: 200,
    },
    {
      titleText: 'Área',
      dataIndex: 'directorio_de_area_clave_y_nombre',
      key: 'directorio_de_area_clave_y_nombre',
      width: 200,
    },
    {
      titleText: 'Puesto',
      dataIndex: 'puesto_descripcion',
      key: 'puesto_descripcion',
      width: 200,
    },
    {
      titleText: 'Tipo de Empleado',
      dataIndex: 'tipo_empleado_descripcion',
      key: 'tipo_empleado_descripcion',
      width: 200,
    },
    {
      titleText: 'Categoría de Empleado',
      dataIndex: 'categoria_nombre',
      key: 'categoria_nombre',
      width: 200,
    },
    {
      titleText: 'Tiempo de Contratación',
      dataIndex: 'tiempo_de_contratacion_descripcion',
      key: 'tiempo_de_contratacion_descripcion',
      width: 200,
    },
    {
      titleText: 'Tipo de Contratación',
      dataIndex: 'tipo_de_contratacion_descripcion',
      key: 'tipo_de_contratacion_descripcion',
      width: 200,
    },
    {
      titleText: 'Tipo de Nómina Empleado',
      dataIndex: 'tipo_de_nomina_empleado_descripcion',
      key: 'tipo_de_nomina_empleado_descripcion',
      width: 200,
    },
    {
      titleText: 'Tipo de Empleado Presupuestal',
      dataIndex: 'tipo_de_empleado_presupuestal_descripcion',
      key: 'tipo_de_empleado_presupuestal_descripcion',
      width: 200,
    },
    {
      titleText: 'Aplica Reloj Checador',
      dataIndex: 'aplica_reloj_checador',
      key: 'aplica_reloj_checador',
      width: 200,
      render: (val) => (val ? 'Si' : 'No'),
    },
    {
      titleText: 'Aplica Horario Especial',
      dataIndex: 'aplica_horario_especial',
      key: 'aplica_horario_especial',
      width: 200,
      render: (val) => (val ? 'Si' : 'No'),
    },
    {
      titleText: 'Jornada',
      dataIndex: 'jornada_descripcion',
      key: 'jornada_descripcion',
      width: 200,
    },
    {
      titleText: 'Días y Horario laboral',
      dataIndex: 'jornada_detalle_descripcion_rango_horario',
      key: 'jornada_detalle_descripcion_rango_horario',
      width: 200,
    },
    {
      titleText: 'Número de Horas Semanales',
      dataIndex: 'descripcion_total_horas',
      key: 'descripcion_total_horas ',
      width: 200,
    },
    {
      titleText: 'Desde Sueldo Mensual Nominal',
      dataIndex: 'desde_sueldo_mensual_nominal',
      key: 'desde_sueldo_mensual_nominal',
      width: 200,
      render: (val) => currencyFormatter(val || 0),
    },
    {
      titleText: 'Hasta Sueldo Mensual Nominal',
      dataIndex: 'hasta_sueldo_mensual_nominal',
      key: 'hasta_sueldo_mensual_nominal',
      width: 200,
      render: (val) => currencyFormatter(val || 0),
    },
    {
      titleText: 'Sueldo Mensual Nominal Asignado',
      dataIndex: 'sueldo_mensual_nominal_asignado',
      key: 'sueldo_mensual_nominal_asignado',
      width: 200,
      render: (val) => currencyFormatter(val || 0),
    },
    {
      titleText: 'Desde Sueldo Diario Nominal',
      dataIndex: 'desde_sueldo_diario_nominal',
      key: 'desde_sueldo_diario_nominal',
      width: 200,
      render: (val) => currencyFormatter(val || 0),
    },
    {
      titleText: 'Hasta Sueldo Diario Nominal',
      dataIndex: 'hasta_sueldo_diario_nominal',
      key: 'hasta_sueldo_diario_nominal',
      width: 200,
      render: (val) => currencyFormatter(val || 0),
    },
    {
      titleText: 'Sueldo Diario Nominal Asignado',
      dataIndex: 'sueldo_diario_nominal_asignado',
      key: 'sueldo_diario_nominal_asignado',
      width: 200,
      render: (val) => currencyFormatter(val || 0),
    },
    {
      titleText: 'Fuente de Financiamiento',
      dataIndex: 'fuentes_de_finnanciamiento',
      key: 'fuentes_de_finnanciamiento',
      width: 200,
      render: (val) => fuentes.find((e) => e.id === val)?.nombre,
    },
    {
      titleText: 'Presupuesto',
      dataIndex: 'presupuesto',
      key: 'presupuesto',
      width: 200,
      // Vacío cuando la plaza no tiene presupuesto capturado (null): mostrar "$0.00" hacía
      // creer que existía un valor 0 y buscarlo no encontraba nada. Un 0 real sí se muestra.
      render: (val) => (val === null || val === undefined || val === '' ? '' : currencyFormatter(val)),
    },
    {
      titleText: 'Tipo de Asignación',
      dataIndex: 'tipo_de_asignacion_de_plaza_nombre',
      key: 'tipo_de_asignacion_de_plaza_nombre',
      width: 200,
    },
    {
      titleText: 'Estatus',
      dataIndex: 'estado_plaza_descripcion',
      key: 'estado_plaza_descripcion ',
      width: 200,
      // Tag con color por estatus (mismos colores que el formulario de edición de esta
      // vista). Se decide por el texto porque el Table a veces llama a render sin el
      // registro (ordenamiento).
      render: (descripcion) => {
        if (!descripcion) return null;
        const upper = String(descripcion).toUpperCase();
        let color = 'blue';
        if (upper.includes('AUTORIZ') || upper.includes('DISPONIBLE')) color = 'green';
        if (upper.includes('ASIGNADA') && !upper.includes('DESASIG')) color = 'purple';
        if (upper.includes('SUSPEND') || upper.includes('DESASIG') || upper.includes('POR ASIGNAR')) color = 'orange';
        if (upper.includes('INACTIV') || upper.includes('CANCEL') || upper.includes('BAJA') || upper.includes('BLOQUEADA')) color = 'red';
        return <Tag color={color}>{descripcion}</Tag>;
      },
    },
    // Fecha de Inactivación/Activación solo son relevantes en los tabs
    // Activa (última vez que se activó) e Inactiva (última vez que se
    // inactivó); se ocultan en el resto para no saturar la tabla.
    ...(activeTab === TAB_ACTIVA || activeTab === TAB_INACTIVA || activeTab === TAB_TODOS ? [
      {
        titleText: 'Fecha de Inactivación',
        dataIndex: 'fecha_de_inactivacion',
        key: 'fecha_de_inactivacion',
        width: 200,
        render: (val) => (val ? moment(val).format('DD/MM/YYYY') : ''),
      },
      {
        titleText: 'Fecha de Activación',
        dataIndex: 'fecha_de_activacion',
        key: 'fecha_de_activacion',
        width: 200,
        render: (val) => (val ? moment(val).format('DD/MM/YYYY') : ''),
      },
    ] : []),
  ];

  // ────────────────────────────────────────────────────────────────
  // Trae TODOS los registros (sin paginación) y abre el exportador
  // reutilizable para que el usuario elija columnas/formato/orden.
  // ────────────────────────────────────────────────────────────────
  const onClickExportarExcel = async () => {
    try {
      setLoading(true);
      const response = await API.get('/catalogos/plazas-vista-optimized');
      const rawData = response.data?.results || response.data || [];

      if (rawData.length === 0) {
        message.error('No se recibieron registros. Revisa la consola y pestaña Network.');
        setLoading(false);
        return;
      }

      setFullDataParaExportar(rawData);
      setShowExportador(true);
      setLoading(false);
    } catch (err) {
      message.error('Error al preparar el Excel. Revisa consola y pestaña Network.');
      setLoading(false);
    }
  };

  const formInstances = [
    form,
  ];

  const fetchData = async (page = 1, q = null) => {
    setLoading(true);
    const _data = await API.get(baseURI, {
      params: {
        page,
        ...paramsEstadoPlaza(activeTab),
        ...(q ?? busquedaGuardada()),
        ...(sujetoFiltro ? { sujeto: sujetoFiltro } : {}),
      },
    });
    const results = formatReceivedClone(_data.data.results);
    setData({ ..._data.data, results });
    setLoading(false);
  };

  const normalizeDataAreas = (_areasFetchArray) => {
    const mainMap = new Map();
    _areasFetchArray.forEach((item) => {
      mainMap.set(item.id, { ...item, children: [] });
    });
    const result = [];
    _areasFetchArray.forEach((item) => {
      if (item.directorio_area_padre) {
        const parent = mainMap.get(item.directorio_area_padre);
        if (parent) {
          parent.children.push(mainMap.get(item.id));
        }
      } else {
        result.push(mainMap.get(item.id));
      }
    });
    const sortByClave = (nodes) => {
      nodes.sort((a, b) => a.clave.localeCompare(b.clave));
      nodes.forEach((node) => {
        if (node.children && node.children.length > 0) {
          sortByClave(node.children);
        }
      });
    };
    sortByClave(result);
    return result;
  };

  const formatTreeSelectData = (nodes) => nodes.map((node) => ({
    title: `${node.clave} - ${node.nombre.trim()}`,
    value: node.id,
    children: node.children ? formatTreeSelectData(node.children) : [],
  }));

  const fetchPaginated = async (page = 1, q = null) => {
    try {
      setLoading(true);
      const response = await API.get(baseURI, {
        params: {
          page,
          ...paramsEstadoPlaza(activeTab),
          ...(q ?? busquedaGuardada()),
          ...(sujetoFiltro ? { sujeto: sujetoFiltro } : {}),
        },
      });
      const results = formatReceivedClone(response.data.results);
      setSelectedRowKeys([]);
      setPageActual(page);
      setData({ ...response.data, results });
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const Catalogos = async () => {
    setLoading(true);
    await checkToken();
    try {
      const [
        _tiposDeActividades,
        _fuentes,
        _tiposEmpleados,
        _categorias,
        _puestos,
        _areas,
        _tiposPlazas,
        _estadosPlazas,
        _tiemposDeContrataciones,
        _tiposDeContrataciones,
        _tiposNominasEmpleados,
        _administraciondeplaza,
        _tiposAsignacion,
        _jornada,
        _jornadadetalle,
        _clasesDeContrataciones,
        _programasPresupuestales,
        _funcionesPresupuestales,
        _tiposDeEmpleadosPresupuestales,
      ] = await Promise.all([
        getTiposDeActividades({ estados_globales: ESTATUS_AUTORIZADO }),
        getFuentesDeFinanciamientoContabilidad(),
        getTiposDeEmpleados(),
        getCategorias(),
        getPuestos({ estados_globales: ESTATUS_AUTORIZADO }),
        getAreas({ estados_globales: ESTATUS_AUTORIZADO }),
        getTiposDePlazas({ estados_globales: ESTATUS_AUTORIZADO }),
        getEstadosPlazas(),
        getTiemposDeContrataciones(),
        getTiposDeContrataciones(),
        getTiposDeNominasEmpleados(),
        getAdministracionDePlazasvistaOptimized(),
        getTiposAsignacion(),
        getJornadas(),
        getJornadasDetalle(),
        getClasesDeContrataciones(),
        getProgramasPresupuestales(),
        getFuncionesPresupuestales(),
        getTiposDeEmpleadosPresupuestales(),
      ]);
      const formattedURS = formatTreeSelectData(normalizeDataAreas(_areas));
      setClasesDeContrataciones(_clasesDeContrataciones);
      setTiposDeActividades(_tiposDeActividades);
      setFlatAreas(_areas);
      setFuentes(_fuentes);
      setTiposEmpleados(_tiposEmpleados);
      setCategorias(_categorias);
      setPuestos(_puestos);
      setAreas(formattedURS);
      setTiposPlazas(_tiposPlazas);
      setEstadosPlazas(_estadosPlazas);
      setTiemposDeContrataciones(_tiemposDeContrataciones);
      setTiposDeContrataciones(_tiposDeContrataciones);
      setTiposNominasEmpleados(_tiposNominasEmpleados);
      setAdminitracionDePlaza(_administraciondeplaza);
      setTiposDeAsignacion(_tiposAsignacion);
      setJornada(_jornada);
      setJornadadetalle(_jornadadetalle);
      setProgramasPresupuestales(_programasPresupuestales);
      setFuncionesPresupuestales(_funcionesPresupuestales);
      setTiposDeEmpleadosPresupuestales(_tiposDeEmpleadosPresupuestales);
      return _areas;
    } catch (err) {
      onError(err, setLoading);
      return [];
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      try {
        const [
          // _fuentes,
          // _tiposEmpleados,
          // _categorias,
          // _nivelesTabulares,
          // _puestos,
          // _areas,
          // _contentTypes,
          // _tabuladoresGenerales,
          // _tiposPlazas,
          // _tabuladoresNominales,
          // _estadosPlazas,
          // _tiemposDeContrataciones,
          // _clasesDeContrataciones,
          // _tiposNominasEmpleados,
          // _administraciondeplaza,
          // _tiposAsignacion,
          // _jornada,
          // _jornadadetalle,
          _tiposRegimenesNominas,
          _tiposChecado,
          _zonasDeSalariosMinimos,
          _tiposDeSueldos,
          _periodicidadesDePagos,
          _tiposDeFunciones,
          _proyectoPresupuestal,
          _data,
        ] = await Promise.all([
          getTiposRegimenesNominas(),
          getChecados(),
          getZonasDeSalariosMinimos(),
          getTiposDeSueldos(),
          getPeriodicidadesDePagos(),
          getTiposDeFunciones({ estados_globales: ESTATUS_AUTORIZADO }),
          getProyectoPresupuestales(),
          // Carga inicial del tab "Todos": sin filtro de estatus.
          getPlazas(paramsEstadoPlaza(TAB_TODOS)),
        ]);
        const _sujetosDeNomina = await getSujetosDeNomina();
        if (Array.isArray(_sujetosDeNomina) && _sujetosDeNomina.length) {
          setSujetosDeNomina(_sujetosDeNomina);
        }
        const results = formatReceivedClone(_data.results);
        // const formattedURS = normalizeDataAreas(_areas);
        // const formattedTreeData = formatTreeSelectData(formattedURS);
        // const formatData = inflateData(_data, _puestos);
        if (mounted) {
          // const sortedFDF = _fuentes.sort((a, b) => a.id - b.id);
          // const fuentesFTree = makeThreeFromCOG(sortedFDF);
          // const normalized = normalizeFDF(fuentesFTree);
          // const FDFUltimoNivel = obtenerNivelMasProfundo(normalized);
          // setFuentes(flattenWithChildren(FDFUltimoNivel));
          // setTiposEmpleados(_tiposEmpleados);
          // setCategorias(_categorias);
          // setNivelesTabulares(_nivelesTabulares);
          // setPuestos(_puestos);
          // setAreas(formattedTreeData);
          // setContentTypes(_contentTypes);
          // setTabuladoresGenerales(_tabuladoresGenerales);
          // setTiposPlazas(_tiposPlazas);
          // setTabuladoresNominales(_tabuladoresNominales);
          // setEstadosPlazas(_estadosPlazas);
          // setTiemposDeContrataciones(_tiemposDeContrataciones);
          // setClasesDeContrataciones(_clasesDeContrataciones);
          // setTiposNominasEmpleados(_tiposNominasEmpleados);
          // setJornada(_jornada);
          // setJornadadetalle(_jornadadetalle);
          // setAdminitracionDePlaza(_administraciondeplaza);
          // setTiposDeAsignacion(_tiposAsignacion);
          setTiposRegimenesNominas(_tiposRegimenesNominas);
          setTiposChecado(_tiposChecado);
          setZonasDeSalariosMinimos(_zonasDeSalariosMinimos);
          setPeriodicidadesDePagos(_periodicidadesDePagos);
          setTiposDeFunciones(_tiposDeFunciones);
          setTiposDeSueldos(_tiposDeSueldos);
          setProyectoPresupuetal(_proyectoPresupuestal);
          setData({ ..._data, results });
        }
      } catch (err) {
        onError(err, setLoading);
      } finally {
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
  }, []);

  // Refiltra el listado cuando cambia el sujeto de nómina seleccionado (Empleado/Becario/Honorario Asimilado)
  const sujetoFiltroMontado = useRef(false);
  useEffect(() => {
    if (!sujetoFiltroMontado.current) {
      sujetoFiltroMontado.current = true;
      return;
    }
    fetchPaginated(1);
  }, [sujetoFiltro]);

  // Refiltra el listado cuando cambia el tab de estatus (Activa/Autorizada/Disponible/Asignada/Inactiva)
  const activeTabMontado = useRef(false);
  useEffect(() => {
    if (!activeTabMontado.current) {
      activeTabMontado.current = true;
      return;
    }
    setSelectedRowKeys([]);
    fetchPaginated(1);
  }, [activeTab]);

  // Modificamos para aceptar "listaAreas" como segundo parámetro
  const getNombreCoordinacion = (areaId, listaAreas = flatAreas) => {
    // Usamos la lista que nos pasen (prioridad) o la del estado (respaldo)
    const dataToUse = (listaAreas && listaAreas.length > 0) ? listaAreas : flatAreas;

    if (!areaId || !dataToUse.length) return '';

    // Mapa para búsqueda rápida usando la lista correcta
    const areaMap = new Map();
    dataToUse.forEach((area) => {
      areaMap.set(area.id, area);
    });

    let areaActual = areaMap.get(areaId);
    if (!areaActual) return '';

    // Subimos por el árbol hasta encontrar el padre raíz (Coordinación)
    while (areaActual.directorio_area_padre) {
      const padre = areaMap.get(areaActual.directorio_area_padre);
      if (!padre) break;
      areaActual = padre;
    }

    return areaActual.nombre;
  };

  // Percepciones y Contribuciones del ejercicio en curso; los anteriores se
  // consultan en la sub-pestaña Historial.
  const loadPlazaCostos = async (plazaId) => {
    if (!plazaId) {
      return;
    }
    setLoading(true);
    try {
      const params = { plaza: plazaId, periodo_fiscal_en_curso: true };
      const [costos, contribuciones] = await Promise.all([
        getPlazaCostos(params),
        getPlazasContribucionesSobreNomina(params),
      ]);
      const results = Array.isArray(costos) ? costos : [];
      setDataPercepciones([...results]);
      setPlazaCostos(results);
      setDataContribuciones(Array.isArray(contribuciones) ? contribuciones : []);
    } catch (error) {
      onError(error, setLoading);
    } finally {
      setLoading(false);
    }
  };

  const loadHistorialCostos = async (plazaId, periodoFiscalId) => {
    if (!plazaId || !periodoFiscalId) {
      setHistorialPercepciones([]);
      setHistorialContribuciones([]);
      return;
    }
    setLoading(true);
    try {
      const params = { plaza: plazaId, periodo_fiscal: periodoFiscalId };
      const [costos, contribuciones] = await Promise.all([
        getPlazaCostos(params),
        getPlazasContribucionesSobreNomina(params),
      ]);
      setHistorialPercepciones(Array.isArray(costos) ? costos : []);
      setHistorialContribuciones(Array.isArray(contribuciones) ? contribuciones : []);
    } catch (error) {
      onError(error, setLoading);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (currentParentTabKey === 'percepciones' && selectedRowKeys.length > 0) {
      const plazaId = selectedRowKeys[0];
      loadPlazaCostos(plazaId);
      if (!periodosFiscales.length) {
        getPeriodosFiscales().then((periodos) => {
          const lista = Array.isArray(periodos) ? periodos : periodos?.results || [];
          setPeriodosFiscales([...lista].sort((a, b) => b.periodo - a.periodo));
        });
      }
    }
  }, [currentParentTabKey, selectedRowKeys]);

  useEffect(() => {
    if (currentParentTabKey === 'percepciones' && selectedRowKeys.length > 0) {
      loadHistorialCostos(selectedRowKeys[0], periodoFiscalHistorial);
    }
  }, [periodoFiscalHistorial]);

  const loadHistorialSueldo = async (plazaId) => {
    if (!plazaId) return;
    try {
      const result = await getHistorialesSueldoPlaza({ plaza: plazaId });
      const list = result?.results || result || [];
      setHistorialSueldo(sortHistorial(list));
    } catch (err) {
      onError(err);
    }
  };

  useEffect(() => {
    if (currentParentTabKey === 'sueldo' && selectedRowKeys.length > 0) {
      loadHistorialSueldo(selectedRowKeys[0]);
    }
  }, [currentParentTabKey, selectedRowKeys]);

  const handleSincronizarPercepciones = async () => {
    if (selectedRowKeys.length === 0) return;
    const plazaId = selectedRowKeys[0];
    setLoading(true);
    try {
      await sincronizarPercepcionesDePlaza(plazaId);
      await loadPlazaCostos(plazaId);
    } catch (error) {
      onError(error, setLoading);
    } finally {
      setLoading(false);
    }
  };

  const onCancel = () => {
    setSelectedRowKeys([]);
    setVisible(false);
    setTipoEmpleado();
    setTabularGeneral();
    setSueldoMensualDesde();
    setSueldoMensualHasta();
    setNivelTabular();
    setPresupuesto();
    setEstadosGlobalesPlazaActual(null);
    form.resetFields();
    setDataPercepciones([]);
    setPlazaCostos([]);
    setDataContribuciones([]);
    setPeriodoFiscalHistorial();
    setHistorialPercepciones([]);
    setHistorialContribuciones([]);
    setSelectedPercepcionKeys([]);
    setHistorialSueldo([]);
    setSelectedHistorialKeys([]);
    setHistorialSeleccionado(null);
  };

  const onClickEdit = async (responseData = null) => {
    setLoading(true);
    setDisable(false);
    await Catalogos();
    const areasRecientes = await Catalogos();
    const [key] = selectedRowKeys;
    const _plaza = await getPlaza(key);
    if (_plaza) {
      form.resetFields();
      setTimeout(() => {
        const formattedClonePlaza = formatReceivedClone(_plaza);
        const puestoValido = puestos.find((p) => p.id === formattedClonePlaza.puesto);
        const fuente_financiamiento = fuentes.find((e) => e?.id === formattedClonePlaza?.fuente_financiamiento)?.id || null;
        const nombreCoordinacion = getNombreCoordinacion(
          formattedClonePlaza.directorio_de_area,
          areasRecientes, // <--- ¡Importante! Pasamos la lista recién obtenida
        );
        form.setFieldsValue({
          ...formattedClonePlaza,
          categoria_nombre: formattedClonePlaza.categoria ?? null,
          coordinacion: nombreCoordinacion,
          tiempo_de_contratacion_descripcion: formattedClonePlaza.tiempo_de_contratacion ?? null,
          tipo_de_contratacion_descripcion: formattedClonePlaza.tipo_de_contratacion ?? null,
          tipo_de_nomina_empleado_descripcion: formattedClonePlaza.tipo_de_nomina_empleado ?? null,
          clase_de_contratacion_descripcion: formattedClonePlaza.clase_de_contratacion ?? null,
          fuente_financiamiento,
          puesto: formattedClonePlaza?.puesto || null,
        });
        setDisableFields(formattedClonePlaza?.estados_globales !== ESTATUS_ACTIVO);
        setEstadosGlobalesPlazaActual(formattedClonePlaza?.estados_globales ?? null);
        setVisible(true);
      });
    }
    setLoading(false);
  };

  const getURValuesToSend = () => {
    const unidad_responsable = form.getFieldValue('unidad_responsable');
    if (unidad_responsable) {
      const [_area, _nivel] = unidad_responsable.split('/');
      const found = contentTypes.find((ct) => ct.nivel.toString() === _nivel);
      const area_content_id = found ? found.id : null;
      return { _area, area_content_id };
    }
    return { _area: null, area_content_id: null };
  };

  const onFinish = async (_values, _continue = false) => {
    try {
      setLoading(true);
      await form.validateFields();
      const [key] = selectedRowKeys;
      const contentValues = getURValuesToSend();
      const rawValues = form.getFieldsValue();
      const jornadaDetalleSeleccionado = rawValues.jornada_detalle
        ? jornadadetalle.find((item) => item.id === rawValues.jornada_detalle)
        : null;
      const totalHorasSoloHrs = jornadaDetalleSeleccionado
        ? parseFloat(jornadaDetalleSeleccionado.descripcion_total_horas.split(':')[0]) || 0
        : 0;
      const totalHoras = totalHorasSoloHrs * 3600;
      const values = {
        ...rawValues,
        clave: rawValues.clave,
        area: contentValues.area_content_id ?? null,
        area_content_id: contentValues._area ? parseInt(contentValues._area, 10) : null,
        tipo_empleado: Array.isArray(rawValues.tipo_empleado)
          ? rawValues.tipo_empleado[0]
          : rawValues.tipo_empleado,
        disponible: true,
        estados_globales: 1,
        total_horas: totalHoras,
        total_horas_solo_hrs: totalHorasSoloHrs,
        fuente_financiamiento: rawValues.fuente_financiamiento ?? null,
        tabulador_nominal: rawValues.tabulador_nominal ?? null,
        directorio_de_area: rawValues.directorio_de_area ?? null,
        desde_sueldo_mensual_nominal: rawValues.desde_sueldo_mensual_nominal ?? null,
        hasta_sueldo_mensual_nominal: rawValues.hasta_sueldo_mensual_nominal ?? null,
        sueldo_mensual_nominal_asignado: rawValues.sueldo_mensual_nominal_asignado ?? null,
        desde_sueldo_diario_nominal: rawValues.desde_sueldo_diario_nominal ?? null,
        hasta_sueldo_diario_nominal: rawValues.hasta_sueldo_diario_nominal ?? null,
        sueldo_diario_nominal_asignado: rawValues.sueldo_diario_nominal_asignado ?? null,
        estado_plaza: key ? rawValues.estado_plaza : 1,
      };

      // Mapeo de _descripcion → campo id real
      if (rawValues.tipo_de_contratacion_descripcion) {
        values.tipo_de_contratacion = rawValues.tipo_de_contratacion_descripcion;
        delete values.tipo_de_contratacion_descripcion;
      }
      if (rawValues.tiempo_de_contratacion_descripcion) {
        values.tiempo_de_contratacion = rawValues.tiempo_de_contratacion_descripcion;
        delete values.tiempo_de_contratacion_descripcion;
      }
      if (rawValues.clase_de_contratacion_descripcion) {
        values.clase_de_contratacion = rawValues.clase_de_contratacion_descripcion;
        delete values.clase_de_contratacion_descripcion;
      }
      if (rawValues.tipo_de_nomina_empleado_descripcion) {
        values.tipo_de_nomina_empleado = rawValues.tipo_de_nomina_empleado_descripcion;
        delete values.tipo_de_nomina_empleado_descripcion;
      }
      if (rawValues.categoria_nombre) {
        values.categoria = rawValues.categoria_nombre;
        delete values.categoria_nombre;
      }
      const cleanedValues = Object.fromEntries(
        Object.entries(values).filter(([_, v]) => v !== undefined && !Number.isNaN(v)),
      );

      // Convertir numéricos a número real
      const numericFields = [
        'desde_sueldo_mensual_nominal',
        'hasta_sueldo_mensual_nominal',
        'sueldo_mensual_nominal_asignado',
        'desde_sueldo_diario_nominal',
        'hasta_sueldo_diario_nominal',
        'sueldo_diario_nominal_asignado',
        'presupuesto',
        'total_horas',
        'total_horas_solo_hrs',
      ];
      numericFields.forEach((field) => {
        if (cleanedValues[field] !== null && cleanedValues[field] !== undefined) {
          cleanedValues[field] = parseFloat(cleanedValues[field]);
        }
      });
      const saved = await (key ? patchPlaza(key, cleanedValues) : postPlaza(cleanedValues));
      if (saved) {
        if (_continue) {
          await fetchData();
          setSelectedRowKeys([saved.id]);
          onClickEdit(saved);
        } else {
          onCancel();
          await fetchData();
        }
      }
    } catch (err) {
      if (err?.errorFields) {
        const [firstError] = err.errorFields;
        const fieldName = firstError?.name?.[0];
        const targetTab = SUELDO_TAB_FIELDS.includes(fieldName) ? 'sueldo' : 'general';
        setCurrentParentTabKey(targetTab);
        message.error(firstError?.errors?.[0] || 'Revisa los campos requeridos antes de guardar.');
        setTimeout(() => form.scrollToField(fieldName, { behavior: 'smooth', block: 'center' }), 100);
        return;
      }
      onError(err, setLoading, formInstances);
    } finally {
      setLoading(false);
    }
  };

  const deleteItem = async () => {
    try {
      setLoading(true);
      await form.validateFields();
      if (selectedRowKeys.length) {
        const [key] = selectedRowKeys;
        const deleted = await deletePlaza(key);
        if (deleted) {
          setVisibleAlert(false);
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const duplicateItem = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys.length) {
        await form.validateFields();
        const [id] = selectedRowKeys;
        const num_copias = +form.getFieldValue('no_copias');
        await duplicarPlaza(id, num_copias);
        await fetchData();
      }
      setLoading(false);
      setVisibleDuplicate(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnRowClick = (record) => {
    if (selectedRowKeys.includes(record.id)) {
      setSelectedRowKeys(selectedRowKeys.filter((id) => id !== record.id));
    } else {
      setSelectedRowKeys([...selectedRowKeys, record.id]);
    }
    if (
      record?.estado_plaza === ESTADO_PLAZA_ASIGNADA
      || record?.estado_plaza === ESTADO_PLAZA_DISPONIBLE
      || record?.estado_plaza === ESTADO_PLAZA_SUSPENDIDA
    ) {
      if (record?.estado_plaza === ESTADO_PLAZA_SUSPENDIDA) {
        setDisableDuplicar(true);
        setRowConditionals(false);
        return form.setFieldsValue(record);
      }
      setDisableDuplicar(false);
      setRowConditionals(false);
      return form.setFieldsValue(record);
    }
    setDisableDuplicar(false);
    setRowConditionals(true);
    return form.setFieldsValue(record);
  };

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    type: 'checkbox',
  };

  const onClickAdd = () => {
    Catalogos();
    onCancel();
    setDisableStatus(false);
    setDisable(false);
    setDisableFields(false);
    setVisible(true);
  };

  const onClickDelete = () => {
    setVisibleAlert(true);
  };

  const onClickDuplicate = async () => {
    form.resetFields(['no_copias']);
    setVisibleDuplicate(true);
  };

  const handleAutorizar = async () => {
    try {
      const mappedSelectedRowKeys = selectedRowKeys.map((val) => ({
        id: val, estado_plaza: ESTADO_PLAZA_AUTORIZADA,
      }));
      const saved = await putAutorizarPlaza(mappedSelectedRowKeys);
      if (saved) {
        setVisibleAuthConfirmation(false);
        setSelectedRowKeys([]);
        await fetchData();
      }
    } catch (err) {
      onError(err);
    }
  };

  // Efecto para evaluar qué acciones están permitidas según las plazas seleccionadas
  useEffect(() => {
    if (selectedRowKeys.length > 0 && data?.results) {
      // Obtenemos los registros completos de las filas seleccionadas
      const selectedRecords = data.results.filter((r) => selectedRowKeys.includes(r.id));

      // REGLA: "Solamente una vez la Plaza estará en estatus Autorizada".
      // Por tanto, solo podemos autorizar plazas que sean "Activas" (recién creadas).
      const canAuth = selectedRecords.every(
        (r) => r.estado_plaza === ESTADO_PLAZA_ACTIVA,
      );
      setCanAutorizar(canAuth);

      // REGLA: Solo se puede Inactivar una Plaza Autorizada o Disponible.
      const canInact = selectedRecords.every(
        (r) => r.estado_plaza === ESTADO_PLAZA_AUTORIZADA
          || r.estado_plaza === ESTADO_PLAZA_DISPONIBLE,
      );
      setCanInactivar(canInact);

      // REGLA: "Se pone en estatus Suspendida con un botón de acción".
      // Permitimos suspender siempre y cuando ninguna de las seleccionadas esté ya suspendida.
      const canSusp = selectedRecords.every(
        (r) => r.estado_plaza !== ESTADO_PLAZA_SUSPENDIDA,
      );
      setCanSuspender(canSusp);

      // REGLA: Solo se puede Reactivar una Plaza Autorizada o Disponible (regresa a Activa).
      const canReact = selectedRecords.every(
        (r) => r.estado_plaza === ESTADO_PLAZA_AUTORIZADA
          || r.estado_plaza === ESTADO_PLAZA_DISPONIBLE,
      );
      setCanReactivar(canReact);

      // Solo se puede Activar una Plaza Inactiva (usado en el tab "Todos").
      setCanActivar(selectedRecords.every((r) => r.estado_plaza === ESTADO_PLAZA_INACTIVA));
    } else {
      // Si no hay nada seleccionado, deshabilitamos todo
      setCanAutorizar(false);
      setCanSuspender(false);
      setCanInactivar(false);
      setCanReactivar(false);
      setCanActivar(false);
    }
  }, [selectedRowKeys, data]);

  const handleSuspender = async () => {
    try {
      const mappedSelectedRowKeys = selectedRowKeys.map((val) => ({
        id: val,
        estado_plaza: ESTADO_PLAZA_SUSPENDIDA,
      }));
      const saved = await putSuspenderPlaza(mappedSelectedRowKeys);
      if (saved) {
        setVisibleAuthSuspender(false);
        setSelectedRowKeys([]);
        await fetchPaginated(1);
      }
    } catch (err) {
      onError(err);
    }
  };

  const handleInactivar = async () => {
    try {
      await formInactivar.validateFields();
    } catch (err) {
      return;
    }
    try {
      const { fecha_inactivacion } = formInactivar.getFieldsValue();
      const saved = await putInactivarPlaza({
        plazas: selectedRowKeys,
        fecha_efectiva: fecha_inactivacion.format('YYYY-MM-DD'),
      });
      if (saved) {
        setVisibleInactivar(false);
        setSelectedRowKeys([]);
        formInactivar.resetFields();
        await fetchPaginated(1);
      }
    } catch (err) {
      onError(err);
    }
  };

  const handleActivar = async () => {
    try {
      await formActivar.validateFields();
    } catch (err) {
      return;
    }
    try {
      const { fecha_activacion } = formActivar.getFieldsValue();
      const saved = await putActivarPlaza({
        plazas: selectedRowKeys,
        fecha_efectiva: fecha_activacion.format('YYYY-MM-DD'),
      });
      if (saved) {
        setVisibleActivar(false);
        setSelectedRowKeys([]);
        formActivar.resetFields();
        await fetchPaginated(1);
      }
    } catch (err) {
      onError(err);
    }
  };

  const handleReactivar = async () => {
    try {
      const mappedSelectedRowKeys = selectedRowKeys.map((val) => ({
        id: val, estado_plaza: ESTADO_PLAZA_ACTIVA,
      }));
      const saved = await putReactivarPlaza(mappedSelectedRowKeys);
      if (saved) {
        setVisibleAuthReactivar(false);
        setSelectedRowKeys([]);
        await fetchData();
      }
    } catch (err) {
      onError(err);
    }
  };

  useEffect(() => {
    if (open) {
      const jornadaInicial = form.getFieldValue('jornada');
      if (jornadaInicial && jornadaSeleccionada !== jornadaInicial) {
        setJornadaSeleccionada(jornadaInicial);
      }
    }
  }, [open]);

  const findCog = (nodes, id) => {
    if (!nodes) return null;
    return nodes.reduce((acc, node) => {
      if (acc) return acc;
      if (node.id === id) return node;
      return findCog(node.children, id) || acc;
    }, null);
  };

  // ── Historial Sueldo Plaza ─────────────────────────────────────────────────
  const handleAddHistorial = () => {
    setHistorialSeleccionado(null);
    formHistorial.resetFields();
    setVisibleHistorialModal(true);
  };

  const handleEditHistorial = () => {
    if (!historialSeleccionado) return;
    formHistorial.setFieldsValue({
      sueldo_diario: historialSeleccionado.sueldo_diario,
      sueldo_mensual: historialSeleccionado.sueldo_mensual,
      fecha_inicial: historialSeleccionado.fecha_inicial
        ? moment(historialSeleccionado.fecha_inicial) : null,
      fecha_final: historialSeleccionado.fecha_final
        ? moment(historialSeleccionado.fecha_final) : null,
    });
    setVisibleHistorialModal(true);
  };

  const onFinishHistorial = async () => {
    try {
      await formHistorial.validateFields();
    } catch {
      return;
    }
    const values = formHistorial.getFieldsValue();
    const plazaId = selectedRowKeys[0];
    const payload = {
      plaza: plazaId,
      sueldo_diario: values.sueldo_diario,
      sueldo_mensual: values.sueldo_mensual,
      fecha_inicial: values.fecha_inicial?.format('YYYY-MM-DD'),
      fecha_final: values.fecha_final?.format('YYYY-MM-DD') || null,
      estados_globales: 1,
    };
    setLoading(true);
    let ok;
    if (historialSeleccionado) {
      ok = await patchHistorialSueldoPlaza(historialSeleccionado.id, payload);
    } else {
      ok = await postHistorialSueldoPlaza(payload);
    }
    if (ok) {
      setVisibleHistorialModal(false);
      formHistorial.resetFields();
      setHistorialSeleccionado(null);
      setSelectedHistorialKeys([]);
      await loadHistorialSueldo(plazaId);
    }
    setLoading(false);
  };

  const confirmDeleteHistorial = async () => {
    if (!historialSeleccionado) return;
    setLoading(true);
    const ok = await deleteHistorialSueldoPlaza(historialSeleccionado.id);
    if (ok) {
      setVisibleDeleteHistorial(false);
      setHistorialSeleccionado(null);
      setSelectedHistorialKeys([]);
      await loadHistorialSueldo(selectedRowKeys[0]);
    }
    setLoading(false);
  };

  const handleAutorizarHistorial = () => {
    if (!historialSeleccionado) return;
    setVisibleConfirmAutorizarHistorial(true);
  };

  const onConfirmAutorizarHistorial = async () => {
    setLoading(true);
    const ok = await patchHistorialSueldoPlaza(
      historialSeleccionado.id,
      { estados_globales: ESTATUS_AUTORIZADO },
    );
    if (ok) {
      setVisibleConfirmAutorizarHistorial(false);
      setHistorialSeleccionado(null);
      setSelectedHistorialKeys([]);
      await loadHistorialSueldo(selectedRowKeys[0]);
    }
    setLoading(false);
  };

  const handleCancelarHistorial = () => {
    if (!historialSeleccionado) return;
    setVisibleConfirmCancelarHistorial(true);
  };

  const onConfirmCancelarHistorial = async () => {
    setLoading(true);
    const ok = await patchHistorialSueldoPlaza(
      historialSeleccionado.id,
      { estados_globales: ESTATUS_CANCELADO },
    );
    if (ok) {
      setVisibleConfirmCancelarHistorial(false);
      setHistorialSeleccionado(null);
      setSelectedHistorialKeys([]);
      await loadHistorialSueldo(selectedRowKeys[0]);
    }
    setLoading(false);
  };

  const columnsHistorial = [
    {
      titleText: 'Sueldo Diario',
      dataIndex: 'sueldo_diario',
      key: 'sueldo_diario',
      width: 160,
      render: (val) => currencyFormatter(val),
    },
    {
      titleText: 'Sueldo Mensual',
      dataIndex: 'sueldo_mensual',
      key: 'sueldo_mensual',
      width: 160,
      render: (val) => currencyFormatter(val),
    },
    {
      titleText: 'Fecha Inicial',
      dataIndex: 'fecha_inicial',
      key: 'fecha_inicial',
      width: 150,
      render: (val) => (val ? moment(val).format('DD/MM/YYYY') : ''),
    },
    {
      titleText: 'Fecha Final',
      dataIndex: 'fecha_final',
      key: 'fecha_final',
      width: 150,
      render: (val) => (val ? moment(val).format('DD/MM/YYYY') : 'Vigente'),
    },
    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales_descripcion',
      key: 'estados_globales_descripcion',
      width: 130,
    },
  ];
  // ──────────────────────────────────────────────────────────────────────────

  const columnsPercepciones = [
    {
      titleText: 'Clave',
      dataIndex: 'percepcion_clave',
      key: 'percepcion_clave',
      width: 150,
    },
    {
      titleText: 'Percepción',
      dataIndex: 'percepcion_descripcion',
      key: 'percepcion_descripcion',
      width: 300,
    },
    {
      titleText: 'Clasificador Objeto del Gasto',
      dataIndex: 'cog_descripcion',
      key: 'cog_descripcion',
      width: 250,
    },
    {
      titleText: 'Fuente de Financiamiento',
      dataIndex: 'fuente_descripcion',
      key: 'fuente_descripcion',
      width: 250,
    },
    {
      titleText: 'Periodicidad',
      dataIndex: 'periodicidad_descripcion',
      key: 'periodicidad_descripcion',
      width: 200,
    },
    {
      titleText: 'Importe Mensual',
      dataIndex: 'importe_mensual',
      key: 'importe_mensual',
      width: 150,
      // Sin importe mensual = percepción que no se paga cada mes (anual, por evento).
      render: (val) => (val === null || val === undefined ? '' : currencyFormatter(val)),
    },
    {
      titleText: 'Importe Anual',
      dataIndex: 'importe_anual',
      key: 'importe_anual',
      width: 150,
      render: (val) => currencyFormatter(val || 0),
    },
    {
      titleText: 'Origen del Importe',
      dataIndex: 'origen_del_importe_descripcion',
      key: 'origen_del_importe_descripcion',
      width: 220,
      render: (val, record) => (
        <>
          {val}
          {record.capturado_manualmente && <Tag color="blue" style={{ marginLeft: 8 }}>Capturado Manualmente</Tag>}
          {!record.capturado_manualmente && record.origen_del_importe === 'SIN_HISTORIAL' && (
            <Tag color="orange" style={{ marginLeft: 8 }}>Por Capturar</Tag>
          )}
        </>
      ),
    },
  ];

  const columnsContribuciones = [
    {
      titleText: 'Contribución Sobre Nómina',
      dataIndex: 'concepto',
      key: 'concepto',
      width: 300,
    },
    {
      titleText: 'Clasificador Objeto del Gasto',
      dataIndex: 'cog_clave',
      key: 'cog_clave',
      width: 350,
      render: (val, record) => (val ? `${val} - ${record.cog_descripcion}` : ''),
    },
    {
      titleText: 'Fuente de Financiamiento',
      dataIndex: 'fuente_clave',
      key: 'fuente_clave',
      width: 300,
      render: (val, record) => (val ? `${val} - ${record.fuente_descripcion}` : ''),
    },
    {
      titleText: 'Importe Mensual',
      dataIndex: 'importe_mensual',
      key: 'importe_mensual',
      width: 200,
      render: (val) => currencyFormatter(val || 0),
    },
    {
      titleText: 'Importe Anual',
      dataIndex: 'importe_anual',
      key: 'importe_anual',
      width: 200,
      render: (val) => currencyFormatter(val || 0),
    },
    {
      titleText: 'Observación',
      dataIndex: 'observacion',
      key: 'observacion',
      width: 300,
      render: (val) => (val ? <Tag color="orange">{val}</Tag> : ''),
    },
  ];

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
    contratacion: [requiredRule],
    estatus: [requiredRule],
    clave: [
      requiredRule,
      {
        pattern: SLUG_PATTERN,
        message: 'Ingrese una clave válida',
      },
    ],
    valor: [
      requiredRule,
      {
        pattern: FLOAT_NUMER_PATTERN,
        message: 'Ingrese un valor válido',
      },
    ],
  };

  const handlePuestoChange = (puestoId) => {
    const puestoSeleccionado = puestos.find((p) => p.id === puestoId);
    if (puestoSeleccionado) {
      form.setFieldsValue({
        aplica_reloj_checador: puestoSeleccionado.aplica_reloj_checador ?? null,
        aplica_horario_especial: puestoSeleccionado.aplica_horario_especial ?? null,
      });
    } else {
      form.setFieldsValue({
        aplica_reloj_checador: null,
        aplica_horario_especial: null,
      });
    }
  };

  const handleEditCosto = () => {
    const [id] = selectedPercepcionKeys;
    const registro = dataPercepciones.find((item) => item.id === id);
    if (registro) {
      setCostoSeleccionado(registro);
      formCosto.setFieldsValue({
        importe_mensual: registro.importe_mensual,
        importe_anual: registro.importe_anual,
      });
      setVisibleEditCosto(true);
    }
  };

  const onFinishEditCosto = async () => {
    try {
      setLoading(true);
      const values = await formCosto.validateFields();
      await patchPlazaCosto(costoSeleccionado.id, values);
      setVisibleEditCosto(false);
      formCosto.resetFields();
      setSelectedPercepcionKeys([]);
      if (selectedRowKeys.length > 0) {
        await loadPlazaCostos(selectedRowKeys[0]);
      }
    } catch (error) {
      onError(error, setLoading);
    } finally {
      setLoading(false);
    }
  };

  const handleRestablecerCosto = async () => {
    const [id] = selectedPercepcionKeys;
    if (!id) return;
    setLoading(true);
    try {
      await patchPlazaCosto(id, { capturado_manualmente: false });
      setSelectedPercepcionKeys([]);
      await loadPlazaCostos(selectedRowKeys[0]);
    } catch (error) {
      onError(error, setLoading);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteCosto = () => {
    const [id] = selectedPercepcionKeys;
    const registro = dataPercepciones.find((item) => item.id === id);
    if (registro) {
      setCostoSeleccionado(registro);
      setVisibleDeleteCosto(true);
    }
  };

  const confirmDeleteCosto = async () => {
    try {
      setLoading(true);
      await deletePlazaCosto(costoSeleccionado.id);
      setVisibleDeleteCosto(false);
      setSelectedPercepcionKeys([]);
      if (selectedRowKeys.length > 0) {
        await loadPlazaCostos(selectedRowKeys[0]);
      }
    } catch (error) {
      onError(error, setLoading);
    } finally {
      setLoading(false);
    }
  };

  const handleOnPercepcionRowClick = (record) => {
    if (selectedPercepcionKeys.includes(record.id)) {
      setSelectedPercepcionKeys(selectedPercepcionKeys.filter((id) => id !== record.id));
    } else {
      setSelectedPercepcionKeys([record.id]);
    }
    setCostoSeleccionado(record);
  };

  const percepcionesRowSelection = {
    selectedRowKeys: selectedPercepcionKeys,
    type: 'radio',
    onChange: (keys) => setSelectedPercepcionKeys(keys),
  };

  const renderFuentes = (value) => `${value.clave} - ${value.nombre}`;

  const getControls = () => {
    const customActions = [
      {
        text: 'Duplicar',
        onClick: () => onClickDuplicate(),
        icon: <CopyOutlined />,
        disabled: selectedRowKeys.length > 1 || disableDuplicar,
      },
      seguimiento.accionSeguimiento,
    ];

    const enTodos = activeTab === TAB_TODOS;

    if (activeTab === TAB_ACTIVA || enTodos) {
      customActions.push({
        text: 'Autorizar',
        onClick: () => setVisibleAuthConfirmation(true),
        permission: { model: 'plaza', action: 'autorizar' },
        icon: <CheckCircleOutlined />,
        disabled: !canAutorizar,
        className: 'success',
      });
    }

    // Suspender: disponible en todos los tabs salvo el de Suspendida (dentro
    // de ese tab todas las filas ya están suspendidas, así que siempre
    // quedaría deshabilitado igual que antes de dividir el listado en tabs).
    // MOSTRAR_SUSPENDER=false lo oculta temporalmente (a petición del
    // usuario) sin quitar el resto de la lógica (handler, modal, permisos).
    if (MOSTRAR_SUSPENDER && activeTab !== TAB_SUSPENDIDA) {
      customActions.push({
        text: 'Suspender',
        onClick: () => setVisibleAuthSuspender(true),
        icon: <StopOutlined />,
        disabled: !canSuspender,
      });
    }

    if (activeTab === TAB_AUTORIZADA || activeTab === TAB_DISPONIBLE || enTodos) {
      customActions.push({
        text: 'INACTIVAR',
        onClick: () => setVisibleInactivar(true),
        permission: { model: 'plaza', action: 'inactivar' },
        icon: <StopOutlined />,
        disabled: !canInactivar,
      });
      customActions.push({
        text: 'Reactivar',
        onClick: () => setVisibleAuthReactivar(true),
        permission: { model: 'plaza', action: 'reactivar' },
        icon: <ReloadOutlined />,
        disabled: !canReactivar,
        className: 'success',
      });
    }

    if (activeTab === TAB_INACTIVA || enTodos) {
      customActions.push({
        text: 'ACTIVAR',
        onClick: () => setVisibleActivar(true),
        permission: { model: 'plaza', action: 'activar' },
        icon: <CheckCircleOutlined />,
        // En "Todos" solo aplica si todas las seleccionadas están Inactivas.
        disabled: selectedRowKeys.length === 0 || (enTodos && !canActivar),
        className: 'success',
      });
    }

    return customActions;
  };

  const tablaPlazas = (
    seguimiento.conBarra(<Table
      cols={[seguimiento.columnaSeguimiento, ...columns]}
      data={data?.results || []}
      pagination={false}
      paginationCallback={fetchPaginated}
      count={data?.count || 0}
      titleTable="Plazas"
      // Los tabs muestran columnas distintas, así que se fija el id para compartir la búsqueda.
      storageId={TABLE_STORAGE_ID}
      allowImport
      baseURI={baseURI}
      rowSelection={rowSelection}
      handleOnRowClick={handleOnRowClick}
      disableDelete={!rowConditionals || selectedRowKeys.length > 1}
      controls={{
        onClickAdd,
        onClickEdit: () => onClickEdit(),
        onClickDelete,
      }}
      customActions={getControls()}
      customActionsDropdown
      customActionsDropdownText="Acciones"
      onExportExcel={onClickExportarExcel}
      permission={permission}
      allowDoubleClick={false}
    />)
  );

  const tabItems = [
    { key: TAB_TODOS, label: 'Todos' },
    { key: TAB_ACTIVA, label: 'Activa' },
    { key: TAB_AUTORIZADA, label: 'Autorizada' },
    { key: TAB_DISPONIBLE, label: 'Disponible' },
    { key: TAB_ASIGNADA, label: 'Asignada' },
    { key: TAB_SUSPENDIDA, label: 'Suspendida' },
    { key: TAB_INACTIVA, label: 'Inactiva' },
  ].map((tab) => ({
    ...tab,
    // Solo la pestaña activa recibe la tabla; el resto queda vacío para no
    // mantener montadas 5 instancias de Table (cada una con sus propios refs
    // internos) cuando antd conserva las pestañas ya visitadas en el DOM.
    children: activeTab === tab.key ? tablaPlazas : null,
  }));

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        {!open ? (
          <>
            {/* Card `tables-container` para que la tabla se ajuste al alto de la ventana
                (igual que Asignación de Plazas / Registro de Incidencias). */}
            <Card bordered={false} className="tables-container">
              <Row style={{ marginBottom: 16 }}>
                <Col xs={24} sm={12} md={8}>
                  <div style={{ marginBottom: 4 }}>Tipo de Sujeto</div>
                  <AntdSelect
                    aria-label="Tipo de Sujeto"
                    style={{ width: '100%' }}
                    allowClear
                    placeholder="Todos"
                    value={sujetoFiltro}
                    onChange={(value) => setSujetoFiltro(value ?? null)}
                    options={sujetosDeNomina.map((s) => ({ value: s.slug, label: s.etiqueta }))}
                  />
                </Col>
              </Row>
              <Tabs
                activeKey={activeTab}
                onChange={setActiveTab}
                items={tabItems}
              />
            </Card>
            <ExportadorExcelPersonalizado
              visible={showExportador}
              onCancel={() => setShowExportador(false)}
              data={fullDataParaExportar}
              fileName={`Plazas_${moment().format('YYYY-MM-DD')}`}
              sheetName="Plazas"
            />
          </>
        ) : (
          <Card
            className="form-container"
            title={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Plazas`}
            extra={(
              <FormSubmitControls
                onFinish={allowGuardarYContinuar ? onFinish : undefined}
                onCancel={onCancel}
                loading={loading}
                onFinishText="Guardar y Continuar"
              />
            )}
            bordered={false}
          >
            {seguimiento.envolverConSeguimiento(
              <Tabs
                type="card"
                activeKey={currentParentTabKey || 'general'}
                onChange={setCurrentParentTabKey}
              >
                <TabPane
                  tab={(
                    <span>
                      <InfoCircleOutlined />
                      {' '}
                      Generales
                    </span>
                  )}
                  key="general"
                  forceRender
                >
                  <Form
                    layout="vertical"
                    form={form}
                    onFinish={onFinish}
                    scrollToFirstError
                    name="general"
                    disabled={disable}
                  >
                    <Card
                      type="inner"
                      size="small"
                      className="inner-block-card"
                      title="1. Identidad De La Plaza"
                      extra="Clave, Nombre Y Clasificación"
                    >
                      <Row gutter={10}>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="clave"
                            label="Clave"
                            hasFeedback
                          >
                            <Input
                              allowClear
                              disabled={disableFields || claveAutoGenerada}
                              placeholder={claveAutoGenerada ? 'Se genera automáticamente' : undefined}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="descripcion"
                            label="Descripción"
                            rules={rules.required}
                            hasFeedback
                          >
                            <Input allowClear disabled={disableFields} />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="tipo_de_plaza"
                            label="Tipo de Plaza"
                            rules={rules.required}
                            hasFeedback
                          >
                            <Select
                              dataSource={tiposPlazas}
                              keyProp="id"
                              labelProp="descripcion"
                              allowClear
                              disabled={disableFields}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="puesto"
                            label="Puesto"
                            rules={[{ required: true, message: 'El campo es requerido' }]}
                            hasFeedback
                          >
                            <Select
                              dataSource={puestos}
                              keyProp="id"
                              labelProp="clave_y_descripcion"
                              allowClear
                              onChange={handlePuestoChange}
                              disabled={disableFields}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="directorio_de_area"
                            label="Área"
                            rules={rules.required}
                            hasFeedback
                          >
                            <TreeSelect
                              showSearch
                              treeNodeFilterProp="title"
                              treeData={areas}
                              disabled={disableFields}
                              onChange={(value) => {
                                const coord = getNombreCoordinacion(value);
                                form.setFieldsValue({ coordinacion: coord });
                              }}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="coordinacion"
                            label="Coordinación"
                          >
                            <Input disabled />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Card>
                    <Card
                      type="inner"
                      size="small"
                      className="inner-block-card"
                      title="2. Empleado Y Contratación"
                      extra="Tipo, Categoría Y Régimen"
                    >
                      <Row gutter={10}>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="tipo_empleado"
                            label="Tipo de Empleado"
                            rules={rules.required}
                            hasFeedback
                          >
                            <Select
                              dataSource={tiposEmpleados}
                              keyProp="id"
                              labelProp="descripcion"
                              allowClear
                              disabled={disableFields}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="categoria_nombre"
                            label="Categoría de Empleado"
                            hasFeedback
                          >
                            <Select
                              dataSource={categorias}
                              keyProp="id"
                              labelProp="nombre"
                              allowClear
                              disabled={disableFields}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="clase_de_contratacion_descripcion"
                            label="Clase de Contratación"
                            rules={rules.required}
                            hasFeedback
                          >
                            <Select
                              dataSource={clasesDeContrataciones}
                              keyProp="id"
                              labelProp="descripcion"
                              allowClear
                              disabled={disableFields}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="tiempo_de_contratacion_descripcion"
                            label="Tiempo de Contratación"
                            rules={rules.required}
                            hasFeedback
                          >
                            <Select
                              dataSource={tiemposDeContrataciones}
                              keyProp="id"
                              labelProp="descripcion"
                              allowClear
                              disabled={disableFields}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="tipo_de_contratacion_descripcion"
                            label="Tipo de Contratación"
                            rules={rules.required}
                            hasFeedback
                          >
                            <Select
                              dataSource={tiposDeContrataciones}
                              keyProp="id"
                              labelProp="descripcion"
                              allowClear
                              disabled={disableFields}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="tipo_de_nomina_empleado_descripcion"
                            label="Tipo de Nómina Empleado"
                            rules={rules.required}
                            hasFeedback
                          >
                            <Select
                              dataSource={tiposNominasEmpleados}
                              keyProp="id"
                              labelProp="descripcion"
                              allowClear
                              disabled={disableFields}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Card>
                    {/* <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          label="Tabulador General"
                          rules={rules.required}
                          hasFeedback
                        >
                          <Select
                            keyProp="clave"
                            labelProp="nombre"
                            keyLabelRender
                            dataSource={tabuladoresGenerales}
                            disabled
                            value={tabuladorGeneral}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <CurrencyInput
                          label="Desde Sueldo Mensual Tabular"
                          value={sueldoMensualDesde}
                          disabled
                        />
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <CurrencyInput
                          label="Hasta Sueldo Mensual Tabular"
                          value={sueldoMensualHasta}
                          disabled
                        />
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          label="Nivel Salarial Tabular"
                          rules={rules.required}
                          hasFeedback
                        >
                          <Select
                            keyProp="id"
                            labelProp="clave"
                            dataSource={nivelesTabulares}
                            disabled
                            value={nivelTabular}
                            render={(val) => `${val?.clave} - ${currencyFormatter(val?.sueldo_diario)}`}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="tabulador_nominal"
                          label="Tabulador Nominal"
                          rules={rules.required}
                          hasFeedback
                        >
                          <Select
                            keyProp="id"
                            labelProp="clave"
                            dataSource={tabuladoresNominales.filter((e) => e.tabulador_general === tabuladorGeneral)}
                            render={(val) => `${val?.clave} - ${val?.nombre}`}
                            disabled={disable}
                          />
                        </Form.Item>
                      </Col> */}
                    {/* <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name={nameAplicaJornada}
                          label="Aplica Jornada y Horario"
                          rules={rules.required}
                          hasFeedback
                        >
                          <Select
                            trueFalse
                            allowClear
                            disabled={disableFields}
                          />
                        </Form.Item>
                      </Col> */}
                    <Card
                      type="inner"
                      size="small"
                      className="inner-block-card"
                      title="3. Jornada Y Horario"
                      extra="Control De Asistencia Y Tiempo De Trabajo"
                    >
                      <Row gutter={10}>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="tipo_de_checado"
                            label="Tipo de Checado"
                            hasFeedback
                          >
                            <Select
                              dataSource={tiposChecado}
                              keyProp="id"
                              labelProp="nombre"
                              allowClear
                              disabled={disableFields}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="aplica_horario_especial"
                            rules={rules.required}
                            label="Aplica Horario Especial"
                            hasFeedback
                          >
                            <Select
                              trueFalse
                              allowClear
                              disabled={disableFields}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name={nameJornada}
                            label="Jornada"
                            rules={watcherAplicaJornada ? rules.required : null}
                            hasFeedback
                          >
                            <Select
                              keyProp="id"
                              labelProp="descripcion"
                              dataSource={jornada}
                              disabled={!watcherAplicaJornada || disableFields}
                              onChange={(value) => {
                                setJornadaSeleccionada(value);
                                form.setFieldsValue({
                                  jornada_detalle: null,
                                  descripcion_total_horas: null,
                                });
                              }}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name={nameJornadaDetalle}
                            rules={watcherAplicaJornada ? rules.required : null}
                            label="Días y Horario Laboral"
                            hasFeedback
                          >
                            <Select
                              keyProp="id"
                              labelProp="descripcion_rango_horario"
                              disabled={!watcherAplicaJornada || disableFields}
                              dataSource={jornadadetalle
                                .filter((item) => item.jornada === jornadaSeleccionada && item.descripcion_rango_horario !== null)
                                .map((item) => ({
                                  id: item.id,
                                  descripcion_rango_horario: item.descripcion_rango_horario,
                                  descripcion_total_horas: item.descripcion_total_horas,
                                }))
                                .filter((item, index, self) => index === self.findIndex((t) => t.descripcion_rango_horario === item.descripcion_rango_horario))}
                              onChange={(value) => {
                                const detalleSeleccionado = jornadadetalle.find(
                                  (item) => item.id === value && item.jornada === jornadaSeleccionada,
                                );
                                form.setFieldValue('descripcion_total_horas', detalleSeleccionado?.descripcion_total_horas || null);
                              }}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="descripcion_total_horas"
                            label="Número de Horas Semanales"
                            hasFeedback
                          >
                            <Input disabled />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="aplica_vigencia"
                            label="Aplica Vigencia"
                            hasFeedback
                          >
                            <Select
                              trueFalse
                              allowClear
                              disabled={disableFields}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Card>
                    <Card
                      type="inner"
                      size="small"
                      className="inner-block-card"
                      title="4. Clasificación Fiscal Y Funcional"
                      extra="SAT, Función, Actividad Y Asignación"
                    >
                      <Row gutter={10}>
                        <Col xs={24} sm={24} md={24}>
                          <Form.Item
                            name="tipo_regimen_nomina"
                            label="Tipo De Regimen Del SAT"
                            hasFeedback
                            rules={rules.required}
                          >
                            <Select
                              labelProp="descripcion"
                              keyProp="id"
                              dataSource={tiposRegimenesNominas}
                              allowClear
                              disabled={disableFields}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="tipo_de_funcion"
                            label="Tipo De Función"
                          >
                            <Select
                              keyProp="id"
                              labelProp="descripcion"
                              dataSource={tiposDeFunciones}
                              disabled={disableFields}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="tipo_de_actividad"
                            label="Tipo De Actividad"
                          >
                            <Select
                              keyProp="id"
                              labelProp="concepto"
                              dataSource={tiposDeActividades}
                              disabled={disableFields}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item label="Tipo de Asignación">
                            <Input
                              allowClear
                              disabled
                            //                     value={
                            //   tiposDeAsignacion.find(
                            //     (item) => item.id
                            //       === administraciondeplaza?.find(
                            //         (adm) => adm.plaza === form.getFieldValue('id'),
                            //       )?.tipo_de_asignacion_de_plaza,
                            //   )?.nombre || ''
                            // }
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Card>
                    <Card
                      type="inner"
                      size="small"
                      className="inner-block-card"
                      title="5. Estatus De La Plaza"
                      extra="Disponibilidad Actual"
                    >
                      <Row gutter={10} align="middle">
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="estado_plaza"
                            label="Estatus"
                            hasFeedback
                          >
                            <Select
                              dataSource={estadosPlazas}
                              keyProp="id"
                              labelProp="descripcion"
                              disabled={disableStatus || !selectedRowKeys.length}
                              defaultValue={1}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item noStyle shouldUpdate>
                            {() => {
                              const estatusPlaza = estadosPlazas.find(
                                (e) => e.id === form.getFieldValue('estado_plaza'),
                              )?.descripcion;
                              if (!estatusPlaza) {
                                return null;
                              }
                              const upper = String(estatusPlaza).toUpperCase();
                              let color = 'blue';
                              if (upper.includes('DISPONIBLE')) {
                                color = 'green';
                              }
                              if (upper.includes('CANCELADA') || upper.includes('BAJA') || upper.includes('BLOQUEADA')) {
                                color = 'red';
                              }
                              return <Tag color={color}>{estatusPlaza}</Tag>;
                            }}
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item noStyle shouldUpdate>
                            {() => {
                              const fechaInactivacion = form.getFieldValue('fecha_de_inactivacion');
                              const fechaActivacion = form.getFieldValue('fecha_de_activacion');
                              if (!fechaInactivacion && !fechaActivacion) {
                                return null;
                              }
                              return (
                                <>
                                  {fechaInactivacion && (
                                    <div>
                                      <Typography.Text type="secondary" style={{ display: 'block' }}>
                                        Fecha de Inactivación
                                      </Typography.Text>
                                      <Typography.Text strong>
                                        {moment(fechaInactivacion).format('DD/MM/YYYY')}
                                      </Typography.Text>
                                    </div>
                                  )}
                                  {fechaActivacion && (
                                    <div>
                                      <Typography.Text type="secondary" style={{ display: 'block' }}>
                                        Fecha de Activación
                                      </Typography.Text>
                                      <Typography.Text strong>
                                        {moment(fechaActivacion).format('DD/MM/YYYY')}
                                      </Typography.Text>
                                    </div>
                                  )}
                                </>
                              );
                            }}
                          </Form.Item>
                        </Col>
                      </Row>
                    </Card>
                    <Form.Item hidden>
                      <Button htmlType="submit" />
                    </Form.Item>
                  </Form>
                </TabPane>
                <TabPane
                  tab={(
                    <span>
                      <DollarOutlined />
                      {' '}
                      Sueldo
                    </span>
                  )}
                  key="sueldo"
                  forceRender
                >
                  <Form
                    layout="vertical"
                    form={form}
                    name="sueldo"
                    disabled={disable}
                  >
                    <Form.Item noStyle shouldUpdate>
                      {() => (
                        <Card
                          size="small"
                          className="inner-block-card"
                        >
                          <Row gutter={10}>
                            <Col xs={24} sm={24} md={12}>
                              <Typography.Text type="secondary" style={{ display: 'block' }}>
                                Sueldo Mensual Nominal Asignado
                              </Typography.Text>
                              <Typography.Text strong style={{ fontSize: 16 }}>
                                {currencyFormatter(form.getFieldValue('sueldo_mensual_nominal_asignado') || 0)}
                              </Typography.Text>
                            </Col>
                            <Col xs={24} sm={24} md={12}>
                              <Typography.Text type="secondary" style={{ display: 'block' }}>
                                Sueldo Diario Nominal Asignado
                              </Typography.Text>
                              <Typography.Text strong style={{ fontSize: 16 }}>
                                {currencyFormatter(form.getFieldValue('sueldo_diario_nominal_asignado') || 0)}
                              </Typography.Text>
                            </Col>
                          </Row>
                        </Card>
                      )}
                    </Form.Item>
                    <Card
                      type="inner"
                      size="small"
                      className="inner-block-card"
                      title="1. Rango Salarial Permitido"
                      extra="Mínimo Y Máximo Para Esta Plaza"
                    >
                      <Row gutter={10}>
                        <Col xs={24} sm={24} md={8}>
                          <CurrencyInput
                            name="desde_sueldo_mensual_nominal"
                            label="Desde Sueldo Mensual Nominal"
                            precision={2}
                            onChange={(val) => form.setFieldValue('desde_sueldo_diario_nominal', (val / 30).toFixed(2))}
                          />
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <CurrencyInput
                            name="hasta_sueldo_mensual_nominal"
                            label="Hasta Sueldo Mensual Nominal "
                            precision={2}
                            onChange={(val) => form.setFieldValue('hasta_sueldo_diario_nominal', (val / 30).toFixed(2))}
                          />
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <CurrencyInput
                            name="sueldo_mensual_nominal_asignado"
                            label="Sueldo Mensual Nominal Asignado"
                            value={form.getFieldValue('sueldo_mensual')}
                            precision={2}
                            onChange={(val) => form.setFieldValue('sueldo_diario_nominal_asignado', (val / 30).toFixed(2))}
                            rules={rules.required}
                          />
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <CurrencyInput
                            name="desde_sueldo_diario_nominal"
                            label="Desde Sueldo Diario Nominal"
                            precision={2}
                          />
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <CurrencyInput
                            name="hasta_sueldo_diario_nominal"
                            label="Hasta Sueldo Diario Nominal"
                            precision={2}
                          />
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <CurrencyInput
                            name="sueldo_diario_nominal_asignado"
                            label="Sueldo Diario Nominal Asignado"
                            precision={2}
                            disabled
                          />
                        </Col>
                      </Row>
                    </Card>
                    <Card
                      type="inner"
                      size="small"
                      className="inner-block-card"
                      title="2. Condiciones De Pago"
                      extra="Periodicidad, Tipo De Sueldo Y Zona"
                    >
                      <Row gutter={10}>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="periodicidad_de_pago"
                            label="Periodicidad de Pago"
                          >
                            <Select
                              labelProp="descripcion"
                              keyProp="id"
                              dataSource={periodicidadesDePagos}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="tipo_de_sueldo"
                            label="Tipo de Sueldo"
                          >
                            <Select
                              labelProp="descripcion"
                              keyProp="id"
                              dataSource={tiposDeSueldos}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="zona_de_salario_minimo"
                            label="Zona de Salario Mínimo"
                          >
                            <Select
                              labelProp="descripcion"
                              keyProp="id"
                              dataSource={zonasDeSalariosMinimos}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Card>
                    {/**
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="fuente_financiamiento"
                          label="Fuente de Financiamiento"
                          hasFeedback
                        >
                          <Select
                            keyProp="id"
                            labelProp="nombre"
                            valueProp="id"
                            dataSource={fuentes}
                            render={renderFuentes}
                          // disabled={disable}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <CurrencyInput
                          name="presupuesto"
                          label="Presupuesto"
                          value={presupuesto}
                          // rules={rules.valor}
                          disabled={disable}
                          hasFeedback
                        />
                      </Col>
   */}
                    <Card
                      type="inner"
                      size="small"
                      className="inner-block-card"
                      title="3. Clasificación Presupuestal"
                      extra="Proyecto, Programa Y Destino"
                    >
                      <Row gutter={10}>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="proyecto_presupuestal"
                            label="Proyecto Presupuestal"
                          >
                            <Select
                              labelProp="descripcion"
                              keyProp="id"
                              dataSource={proyectoPresupuestal}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="programa_presupuestal"
                            label="Programa Presupuestal"
                            rules={rules.required}
                            hasFeedback
                          >
                            <Select
                              dataSource={programasPresupuestales}
                              keyProp="id"
                              labelProp="descripcion"
                              render={(item) => `${item.clave} - ${item.descripcion}`}
                              allowClear
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="destino_presupuestal"
                            label="Destino Presupuestal"
                            rules={rules.required}
                            hasFeedback
                          >
                            <Select
                              dataSource={funcionesPresupuestales}
                              keyProp="id"
                              labelProp="nombre"
                              render={(item) => `${item.numero || ''} - ${item.nombre}`}
                              allowClear
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="tipo_de_empleado_presupuestal"
                            label="Tipo de Empleado Presupuestal"
                            rules={rules.required}
                            hasFeedback
                          >
                            <Select
                              dataSource={tiposDeEmpleadosPresupuestales}
                              keyProp="id"
                              labelProp="clave_y_descripcion"
                              allowClear
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Card>
                    <Form.Item hidden>
                      <Button htmlType="submit" />
                    </Form.Item>
                  </Form>

                  <Table
                    titleTable="Historial de Sueldos"
                    cols={columnsHistorial}
                    data={historialSueldo}
                    pagination={false}
                    rowSelection={{
                      selectedRowKeys: selectedHistorialKeys,
                      onChange: (keys, rows) => {
                        setSelectedHistorialKeys(keys);
                        setHistorialSeleccionado(rows[0] || null);
                      },
                      type: 'radio',
                    }}
                    handleOnRowClick={(record) => {
                      setSelectedHistorialKeys([record.id]);
                      setHistorialSeleccionado(record);
                    }}
                    controls={{
                      onClickAdd: handleAddHistorial,
                      onClickEdit: handleEditHistorial,
                      onClickDelete: () => setVisibleDeleteHistorial(true),
                    }}
                    customActions={[
                      {
                        permission: { model: 'historialsueldoplaza', action: 'cancelar' },
                        onClick: handleCancelarHistorial,
                        text: 'Cancelar',
                        icon: <CloseCircleOutlined />,
                        disabledBySelection: false,
                        className: 'cancel',
                        disabled: !historialSeleccionado
                          || historialSeleccionado?.estados_globales === ESTATUS_CANCELADO,
                      },
                      {
                        permission: { model: 'historialsueldoplaza', action: 'autorizar' },
                        onClick: handleAutorizarHistorial,
                        text: 'Autorizar',
                        icon: <CheckCircleOutlined />,
                        disabledBySelection: false,
                        className: 'success',
                        disabled: !historialSeleccionado
                          || historialSeleccionado?.estados_globales === ESTATUS_AUTORIZADO
                          || historialSeleccionado?.estados_globales === ESTATUS_CANCELADO,
                      },
                    ]}
                    permission={permission}
                  />

                  <Modal
                    open={visibleHistorialModal}
                    title={(
                      <FormSubmitControls
                        label={historialSeleccionado ? 'Editar Sueldo' : 'Agregar Sueldo'}
                        onFinish={onFinishHistorial}
                        onCancel={() => {
                          setVisibleHistorialModal(false);
                          formHistorial.resetFields();
                        }}
                        loading={loading}
                      />
                    )}
                    footer={null}
                    onCancel={() => {
                      setVisibleHistorialModal(false);
                      formHistorial.resetFields();
                    }}
                    closable={false}
                    maskClosable={!loading}
                    keyboard={!loading}
                    destroyOnClose
                  >
                    <Form
                      form={formHistorial}
                      layout="vertical"
                      onFinish={onFinishHistorial}
                    >
                      <Row gutter={16}>
                        <Col xs={24} sm={12}>
                          <CurrencyInput
                            name="sueldo_mensual"
                            label="Sueldo Mensual"
                            rules={[{ required: true, message: 'Requerido' }]}
                            onChange={(val) => formHistorial.setFieldValue('sueldo_diario', (val / 30).toFixed(2))}
                          />
                        </Col>
                        <Col xs={24} sm={12}>
                          <CurrencyInput
                            name="sueldo_diario"
                            label="Sueldo Diario"
                            rules={[{ required: true, message: 'Requerido' }]}
                          />
                        </Col>
                        <Col xs={24} sm={12}>
                          <Form.Item
                            name="fecha_inicial"
                            label="Fecha Inicial"
                            rules={[{ required: true, message: 'Requerido' }]}
                          >
                            <DatePicker style={{ width: '100%' }} format="DD/MM/YYYY" />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={12}>
                          <Form.Item
                            name="fecha_final"
                            label="Fecha Final"
                          >
                            <DatePicker style={{ width: '100%' }} format="DD/MM/YYYY" />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Form.Item hidden>
                        <Button htmlType="submit" />
                      </Form.Item>
                    </Form>
                  </Modal>

                  <ModalDelete
                    open={visibleDeleteHistorial}
                    onCancel={() => setVisibleDeleteHistorial(false)}
                    onDelete={confirmDeleteHistorial}
                    content={`el registro de sueldo del ${historialSeleccionado?.fecha_inicial || ''}`}
                    loading={loading}
                  />

                  <ModalConfirmation
                    open={visibleConfirmAutorizarHistorial}
                    onFinish={onConfirmAutorizarHistorial}
                    ConfirmAutorize
                    onCancel={() => setVisibleConfirmAutorizarHistorial(false)}
                    contentTitle={`Autorizar el sueldo vigente desde ${historialSeleccionado?.fecha_inicial || ''}`}
                    loading={loading}
                  />

                  <ModalConfirmation
                    open={visibleConfirmCancelarHistorial}
                    onFinish={onConfirmCancelarHistorial}
                    Confirm
                    onCancel={() => setVisibleConfirmCancelarHistorial(false)}
                    contentTitle={`Cancelar el sueldo vigente desde ${historialSeleccionado?.fecha_inicial || ''}`}
                    loading={loading}
                  />

                </TabPane>
                <TabPane
                  tab={(
                    <span>
                      {' '}
                      Costo
                    </span>
                  )}
                  key="percepciones"
                  forceRender
                  disabled={!selectedRowKeys.length}
                >
                  <Tabs
                    type="card"
                    activeKey={activeTabPercepciones}
                    onChange={setActiveTabPercepciones}
                  >
                    <TabPane tab="Percepciones" key="percepciones-costos" forceRender>
                      <Table
                        titleTable="Percepciones por costos"
                        data={dataPercepciones}
                        cols={columnsPercepciones}
                        pagination={false}
                        rowSelection={percepcionesRowSelection}
                        handleOnRowClick={handleOnPercepcionRowClick}
                        controls={{
                          onClickEdit: handleEditCosto,
                          onClickDelete: handleDeleteCosto,
                        }}
                        customActions={[
                          {
                            text: 'Actualizar',
                            onClick: () => handleSincronizarPercepciones(),
                            icon: <ReloadOutlined />,
                            disabledBySelection: false,
                            permission: { model: 'plazacosto', action: 'change' },
                          },
                          {
                            text: 'Restablecer Cálculo',
                            onClick: () => handleRestablecerCosto(),
                            icon: <UndoOutlined />,
                            disabledBySelection: true,
                            disabled: !dataPercepciones
                              .find((item) => item.id === selectedPercepcionKeys[0])?.capturado_manualmente,
                            permission: { model: 'plazacosto', action: 'change' },
                          },
                        ]}
                        permission={permission}
                      />

                      <Modal
                        title={(
                          <FormSubmitControls
                            label="Editar Costo de Plaza"
                            onFinish={onFinishEditCosto}
                            onCancel={() => {
                              setVisibleEditCosto(false);
                              formCosto.resetFields();
                            }}
                            loading={loading}
                          />
                        )}
                        footer={null}
                        open={visibleEditCosto}
                        onCancel={() => {
                          setVisibleEditCosto(false);
                          formCosto.resetFields();
                        }}
                        closable={false}
                        maskClosable={!loading}
                        keyboard={!loading}
                        destroyOnClose
                      >
                        <Form
                          form={formCosto}
                          layout="vertical"
                          onFinish={onFinishEditCosto}
                        >
                          <Row gutter={16}>
                            <Col span={24}>
                              <CurrencyInput
                                name="importe_mensual"
                                label="Importe Mensual"
                              />
                            </Col>
                            <Col span={24}>
                              <CurrencyInput
                                name="importe_anual"
                                label="Importe Anual"
                              />
                            </Col>
                          </Row>
                          <Form.Item hidden>
                            <Button htmlType="submit" />
                          </Form.Item>
                        </Form>
                      </Modal>
                      <ModalDelete
                        open={visibleDeleteCosto}
                        onCancel={() => setVisibleDeleteCosto(false)}
                        onDelete={confirmDeleteCosto}
                        content={` ${costoSeleccionado?.percepcion_descripcion || ''}?`}
                        loading={loading}
                      />
                    </TabPane>
                    <TabPane tab="Contribuciones sobre Nómina" key="contribuciones-nomina" forceRender>
                      <Table
                        titleTable="Contribuciones sobre la Nómina"
                        data={dataContribuciones}
                        cols={columnsContribuciones}
                        pagination={false}
                      />
                    </TabPane>
                    <TabPane tab="Historial" key="historial-costos" forceRender>
                      <Row gutter={16}>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item label="Periodo Fiscal">
                            <Select
                              dataSource={periodosFiscales}
                              keyProp="id"
                              labelProp="periodo"
                              value={periodoFiscalHistorial}
                              onChange={setPeriodoFiscalHistorial}
                              allowClear
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Table
                        titleTable="Percepciones"
                        data={historialPercepciones}
                        cols={columnsPercepciones}
                        pagination={false}
                      />
                      <Table
                        titleTable="Contribuciones sobre la Nómina"
                        data={historialContribuciones}
                        cols={columnsContribuciones}
                        pagination={false}
                      />
                    </TabPane>
                  </Tabs>
                </TabPane>
              </Tabs>,
              'esta Plaza',
            )}
          </Card>
        )}
        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          open={visibleAlert}
          content={`Plaza ${form.getFieldValue('clave')}`}
          loading={loading}
        />
        <ModalDuplicate
          onDuplicate={duplicateItem}
          onCancel={() => setVisibleDuplicate(false)}
          form={form}
          open={visibleDuplicate}
          contentUser={[
            form.getFieldValue('clave'),
            form.getFieldValue('puesto_descripcion') || 'Sin descripción',
          ]}
          loading={loading}
          puesto={form.getFieldValue('puesto_descripcion') || 'Sin descripción'}
        />
        <ModalConfirmation
          onFinish={handleAutorizar}
          onCancel={() => {
            setVisibleAuthConfirmation(false);
            setSelectedRowKeys([]);
          }}
          open={visibleAuthConfirmation}
          loading={loading}
          contentTitle={
            selectedRowKeys.length === 1
              ? `Autorizar la Plaza ${form.getFieldValue('clave')}`
              : `Autorizar las ${selectedRowKeys.length} Plazas Seleccionadas`
          }
          ConfirmAutorize
        />
        <ModalConfirmation
          onFinish={handleSuspender}
          onCancel={() => {
            setVisibleAuthSuspender(false);
            setSelectedRowKeys([]);
          }}
          open={visibleAuthSuspender}
          loading={loading}
          contentTitle={
            selectedRowKeys.length === 1
              ? `Suspender la Plaza ${form.getFieldValue('clave')}`
              : `Suspender las ${selectedRowKeys.length} Plazas Seleccionadas`
          }
          ConfirmSuspension
          subMessage
        />
        <ModalConfirmation
          onFinish={handleInactivar}
          onCancel={() => {
            setVisibleInactivar(false);
            formInactivar.resetFields();
          }}
          open={visibleInactivar}
          loading={loading}
          contentTitle={
            selectedRowKeys.length === 1
              ? `Inactivar la Plaza ${form.getFieldValue('clave')}`
              : `Inactivar las ${selectedRowKeys.length} Plazas Seleccionadas`
          }
          ConfirmInactive
          subMessage
          extraContent={(
            <Form form={formInactivar} layout="vertical" style={{ marginTop: 16 }}>
              <Form.Item
                name="fecha_inactivacion"
                label="Fecha de Inactivación"
                rules={[{ required: true, message: 'La fecha de inactivación es obligatoria' }]}
              >
                <DatePicker style={{ width: '100%' }} format="DD/MM/YYYY" />
              </Form.Item>
            </Form>
          )}
        />
        <ModalConfirmation
          onFinish={handleActivar}
          onCancel={() => {
            setVisibleActivar(false);
            formActivar.resetFields();
          }}
          open={visibleActivar}
          loading={loading}
          contentTitle={
            selectedRowKeys.length === 1
              ? `Activar la Plaza ${form.getFieldValue('clave')}`
              : `Activar las ${selectedRowKeys.length} Plazas Seleccionadas`
          }
          ConfirmActive
          extraContent={(
            <Form form={formActivar} layout="vertical" style={{ marginTop: 16 }}>
              <Form.Item
                name="fecha_activacion"
                label="Fecha de Activación"
                rules={[{ required: true, message: 'La fecha de activación es obligatoria' }]}
              >
                <DatePicker style={{ width: '100%' }} format="DD/MM/YYYY" />
              </Form.Item>
            </Form>
          )}
        />
        <ModalConfirmation
          onFinish={handleReactivar}
          onCancel={() => {
            setVisibleAuthReactivar(false);
            setSelectedRowKeys([]);
          }}
          open={visibleAuthReactivar}
          loading={loading}
          contentTitle={
            selectedRowKeys.length === 1
              ? `Reactivar la Plaza ${form.getFieldValue('clave')}`
              : `Reactivar las ${selectedRowKeys.length} Plazas Seleccionadas`
          }
          ConfirmAutorize
        />
        {seguimiento.modalSeguimiento}
      </Spin>
    </Row>
  );
};

export default CategoriaDePuesto;
